import { Component } from 'react';
import axios from "axios";
import VisibilityIcon from "@material-ui/icons/Visibility";
import VisibilityOffIcon from "@material-ui/icons/VisibilityOff";
import CreateIcon from "@material-ui/icons/Create";
import { connect } from "react-redux";
import "../../../components/Client/signatureCanvas.css";
import SignatureCanvas from "react-signature-canvas";
import { addSettings } from "../../../actions";
import {
  ValidateEmail,
  axiosConfig,
  normalizePhone,
  ValidatePasswordPattern,
  formatAsCurrency,
  REPLACECONTENTCLIENT,
} from "../../../config/utility";
import {
  getSingleQuotation,
  listSingleClient,
  getAssignedQuotationSettings,
  saveQuotationComment,
  listServicesWithPrice,
  saveChooseQuotationSignature,
  saveQuotationSignature,
  saveSalesOrder,
  rejectQuotation,
  getUnSignedServiceAgreements,
} from "./../../../config/client_api_calls";

import $ from "jquery";

import Questions from "../../../components/Client/RequestForQuotation/questions";
import ExtraDetails from "../../../components/Client/RequestForQuotation/extra";

import DataTableExtended from "../../../components/Tables/DataTableExtended";
import { tableLoader } from "../../../components/ContentLoaders/table_loader";
import { tableLoaderListing } from "../../../components/ContentLoaders/table_loader_listing";
import { HeadBodyGrid } from "../../../components/ContentLoaders/newLoaders/HeadBodyGrid";
import { CheckboxList } from "../../../components/ContentLoaders/newLoaders/CheckboxList";
import { Chat } from "../../../components/ContentLoaders/newLoaders/Chat";
import MsaWarning from "../ExtraComponents/MsaWarning";
import SettingsError from "../ExtraComponents/SettingsError";
import PageTitle from "../ExtraComponents/PageTitle";
import HelperClass from "./../../../config/helperClass";
import {
  THEME_TEXT_COLOR,
  THEME_COLOR,
  APP_LIVE_URL,
  API_URL,
  APP_URL,
} from "./../../../config/config";
import MutextField from "@material-ui/core/TextField";
import TextareaAutosize from "@material-ui/core/TextareaAutosize";

import Tooltip from "@material-ui/core/Tooltip";
import dateFormat, { masks } from "dateformat";

import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import Link from "@material-ui/core/Link";
import HomeIcon from "@material-ui/icons/Home";
import Typography from "@material-ui/core/Typography";
//import { Editor } from "@tinymce/tinymce-react";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import DecoupledEditor from "@ckeditor/ckeditor5-build-decoupled-document";
import { CopyToClipboard } from "react-copy-to-clipboard";
import htmlToFormattedText from "html-to-formatted-text";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import html2canvas from "html2canvas";
import parsePhoneNumberFromString from "libphonenumber-js";

const animatedComponents = makeAnimated();

const auth = new HelperClass();

class ViewQuotation extends Component {
  constructor() {
    super();

    this.state = {
      tableData: [],
      serviceData: [],
      tableDataBundle: [],
      completeData: [],
      defaultServices: [],
      errorMessage: "",
      serviceId: "",
      successMessage: "",
      successMessagePay: "",
      errorMessagePay: "",
      errorMessagePayTitle: "",
      tableLoader: true,
      tableLoaderListing: true,
      mcqLoader: true,
      addressLoader: true,
      commentLoader: true,
      tableLoaderBundle: true,
      errorMessageEmail: "",
      VerifyBusinessButton: false,
      VerifyFinancialButton: false,
      VerifyTradeButton: false,
      verifyDetailsButton: false,
      resendPinButton: false,
      finalPayButton: false,
      rejectionButton: false,
      successMessageEmail: "",
      errorMessagePassword: "",
      errorMessageConsent: "",
      errorMessageFinal: "",
      convErrorMessage: "",
      service_success_message: "",
      service_already_eists_message: "",
      payment_method: "bank",
      bank_account_details: "",
      wire_transfer_details: "",
      bank_account_details_plain: "",
      wire_transfer_details_plain: "",
      final_form_step: "signature",
      quote_attachement: "",
      quote_attachement_button: false,
      step: 1,
      email: "",
      copied: false,
      cpied_value: "",
      show_signature: false,
      disabled: false,
      //Client Details
      client_name: "",
      client_company: "",
      client_email: "",
      client_phone: "",
      client_address: "",
      client_address2: "",
      client_city: "",
      client_state: "",
      client_zip: "",
      client_country: "",
      //Reseller Details
      reseller_name: "",
      reseller_company: "",
      reseller_email: "",
      reseller_phone: "",
      reseller_address: "",
      reseller_city: "",
      reseller_state: "",
      reseller_zip: "",
      //Discount Entries
      discount_type: "amount",
      discount_value: 0,
      discount_value_total: 0,
      discount_reason: "",
      //Shipping Entries
      shipping_title: "",
      shipping_value: 0,
      shipping_value_total: 0,
      quotation_signature: "",
      //Tax Details
      tax_type: "amount",
      tax_value: 0,
      tax_value_total: 0,
      tax_reason: "",
      //Quotation Settings
      quotation_notes: "",
      payment_terms: "",
      currency: "USD",
      contact_person: "",
      contact_email: "",
      validity: "",
      errorMessageInfo: "",
      successMessageInfo: "",
      info_button: false,
      conversations: [],
      quote_accountno: "",
      quote_comment_button: false,
      rejection_reason: "",
      rejectErrorMessage: "",
      rejectErrorMessageTitle: "",
      rejectSuccessMessage: "",
      quote_comment: "",

      service_grand_total: 0,
      service_grand_sub_total: 0,
      order_summary_items: [],
      rows: [],
      all_Services: [],
      all_select_services: [],
      all_select_services_optional: [],

      signatureText: "",
      signatureClass: "'Amita', cursive",
      signature_type: "draw",

      quote_status: "",
      agreement_accountno: "",
      agreementTitle: "",
      agreementContent: "",

      isEditorReady: false,

      unsignedArray: [],

      rows_service_temp: [
        {
          temp_serv_id: "row-135",
          temp_serv_data: {
            temp_serv_inner_id: 940,
            temp_serv_inner_name: "Item 1",
            temp_serv_inner_quantity: 2,
            temp_serv_inner_unit: "sbc",
            temp_serv_inner_price: 10,
            temp_serv_inner_total: 10,
            temp_serv_inner_type: "service",
          },
        },
      ],
      rows_optional: [],
      rows_optional_temp: [
        {
          temp_opt_id: "row-145",
          temp_opt_data: {
            temp_opt_inner_id: 940,
            temp_opt_inner_name: "Item 1",
            temp_opt_inner_quantity: 2,
            temp_opt_inner_unit: "sbc",
            temp_opt_inner_price: 10,
            temp_opt_inner_total: 10,
            temp_opt_inner_type: "service",
          },
        },
      ],
      rows_custom_temp: [
        {
          temp_id: "row-125",
          temp_data: {
            temp_inner_id: 94,
            temp_inner_name: "Item 1",
            temp_inner_quantity: 2,
            temp_inner_unit: "sbc",
            temp_inner_price: 10,
            temp_inner_total: 10,
            temp_inner_type: "custom",
          },
        },
      ],
    };

    this.cursiveFonts = [
      { name: "Your Signature", value: "'Amita', cursive" },
      { name: "Your Signature", value: "'Bad Script', cursive" },
      { name: "Your Signature", value: "'Damion', cursive" },
      { name: "Your Signature", value: "'Dancing Script', cursive" },
      { name: "Your Signature", value: "'Felipa', cursive" },
      { name: "Your Signature", value: "'Julee', cursive" },
      { name: "Your Signature", value: "'Kaushan Script', cursive" },
      { name: "Your Signature", value: "'Lugrasimo', cursive" },
      { name: "Your Signature", value: "'Pacifico', cursive" },
      { name: "Your Signature", value: "'Sofia', cursive" },
      { name: "Your Signature", value: "'Yellowtail', cursive" },
      // Add more cursive fonts here
    ];
  }

  async componentDidMount() {
    let quote_accountno = this.props.props.match.params.quote_accountno;
    this.setState({ quote_accountno: quote_accountno });
    //console.log("quote_accountno: ", quote_accountno);
    if (
      this.props.props.match.params.quote_accountno &&
      this.props.props.match.params.quote_accountno !== ""
    ) {
      this.getSingleQuotation(quote_accountno);
      this.getQuotationSettings(quote_accountno);
    }

    this.getSingleClient();
    this.getServices();
    /*let signaturePad;
    $('#modalSignAndPay').on('shown.bs.modal',function(e){
        let canvas = $("#signature-pad canvas");
        let parentWidth = $(canvas).parent().outerWidth();
        let parentHeight = $(canvas).parent().outerHeight();
        canvas.attr("width", parentWidth+'px')
              .attr("height", parentHeight+'px');
              this.signaturePad = new SignaturePad(canvas[0], {
            backgroundColor: 'rgb(255, 255, 255)'
        });
    })*/
  }

  getDecimalPoint = () => {
    if (
      this.props.quotationSettings[0]?.decimal_point &&
      this.props.quotationSettings[0]?.decimal_point !== ""
    ) {
      const decimalPoint = this.props.quotationSettings[0]?.decimal_point;
      return decimalPoint !== "" ? Number(decimalPoint) : 2;
    }
    return 2;
  };

  getBillingDecimalPoint = () => {
    if (
      this.props.quotationSettings[0]?.billing_decimal_point &&
      this.props.quotationSettings[0]?.billing_decimal_point !== ""
    ) {
      const decimalPoint =
        this.props.quotationSettings[0]?.billing_decimal_point;
      return decimalPoint !== "" ? Number(decimalPoint) : 2;
    }
    return 2;
  };

  getServices = async () => {
    const servicesResponce = await listServicesWithPrice(
      auth.getClientAccount(),
      auth.getClientToken()
    );
    // console.log("getServices: ", servicesResponce.data);
    if (
      servicesResponce.data.status === 403 ||
      servicesResponce.data.errors === "authentication missing" ||
      servicesResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (servicesResponce.data.status === 404) {
      //window.location.replace("/error");
    } else if (
      servicesResponce.data.status === 200 &&
      servicesResponce.data.message === "success"
    ) {
      let all_select_services = [];
      if (servicesResponce.data.data && servicesResponce.data.data.length > 0) {
        for (let i = 0; i < servicesResponce.data.data.length; i++) {
          let newArr = {
            label: servicesResponce.data.data[i][1],
            value: servicesResponce.data.data[i][0],
          };
          all_select_services.push(newArr);
        }
      }
      this.setState({
        all_select_services: all_select_services,
        all_select_services_optional: all_select_services,
        all_services: servicesResponce.data.data,
      });
    }
  };

  getSingleQuotation = async (quote_accountno) => {
    const servicesResponce = await getSingleQuotation(
      auth.getClientAccount(),
      auth.getClientToken(),
      quote_accountno
    );
    // console.log("getSingleQuotation: ", servicesResponce.data);
    if (
      servicesResponce.data.status === 403 ||
      servicesResponce.data.errors === "authentication missing" ||
      servicesResponce.data.errors === "jwt expired"
    ) {
      auth.clientLogout();
    } else if (servicesResponce.data.status === 404) {
      //window.location.replace("/error");
    } else if (
      servicesResponce.data.status === 200 &&
      servicesResponce.data.message === "success"
    ) {
      let generic_decimal = servicesResponce.data.decimal_point;
      let billing_decimal = servicesResponce.data.billing_decimal_point;

      let discount_value_total = 0;
      let discount_type = "amount";
      let discount_value = 0;
      let discount_reason = "";
      if (
        servicesResponce.data.data[0]["discounts"] &&
        servicesResponce.data.data[0]["discounts"].length > 0
      ) {
        discount_value_total =
          servicesResponce.data.data[0]["discounts"][0]["discount_total"];
        discount_type =
          servicesResponce.data.data[0]["discounts"][0]["discount_type"];
        discount_value =
          servicesResponce.data.data[0]["discounts"][0]["discount_value"];
        discount_reason =
          servicesResponce.data.data[0]["discounts"][0]["discount_reason"];
      }
      let tax_value_total = 0;
      let tax_type = "amount";
      let tax_value = 0;
      let tax_reason = "";
      if (
        servicesResponce.data.data[0]["taxes"] &&
        servicesResponce.data.data[0]["taxes"].length > 0
      ) {
        tax_value_total =
          servicesResponce.data.data[0]["taxes"][0]["tax_total"];
        tax_type = servicesResponce.data.data[0]["taxes"][0]["tax_type"];
        tax_value = servicesResponce.data.data[0]["taxes"][0]["tax_value"];
        tax_reason = servicesResponce.data.data[0]["taxes"][0]["tax_reason"];
      }
      let shipping_value_total = 0;
      let shipping_title = "";
      let shipping_value = "";
      if (
        servicesResponce.data.data[0]["shipping"] &&
        servicesResponce.data.data[0]["shipping"].length > 0
      ) {
        shipping_value_total =
          servicesResponce.data.data[0]["shipping"][0]["shipping_value"];
        shipping_title =
          servicesResponce.data.data[0]["shipping"][0]["shipping_title"];
        shipping_value =
          servicesResponce.data.data[0]["shipping"][0]["shipping_value"];
      }
      //console.log("rfq_questions: "+servicesResponce.data.data);
      let servicesRows = [];
      let total = 0;
      if (
        servicesResponce.data.data[0]["quote_services"] &&
        servicesResponce.data.data[0]["quote_services"].length > 0
      ) {
        let rfq_services = servicesResponce.data.data[0]["quote_services"];
        for (let i = 0; i < rfq_services.length; i++) {
          let sku = rfq_services[i]["sku"];
          if (rfq_services[i]["item_type"] === "custom") {
            if (rfq_services[i]["sku"] && rfq_services[i]["sku"] !== "") {
              sku = rfq_services[i]["sku"];
            } else {
              sku = "CU-" + i;
            }
          }
          let newArray = {
            id: `row-${i}`,
            data: {
              id: rfq_services[i]["service_id"],
              sku: sku,
              name: rfq_services[i]["service_name"],
              description: rfq_services[i]["description"],
              quantity: rfq_services[i]["quantity"],
              unit: rfq_services[i]["service_unit"],
              price: Number(rfq_services[i]["service_price"]).toFixed(
                generic_decimal
              ),
              total: Number(
                Number(rfq_services[i]["quantity"]) *
                rfq_services[i]["service_price"]
              ).toFixed(billing_decimal),
              type: rfq_services[i]["item_type"],
            },
          };
          servicesRows.push(newArray);
          total =
            total +
            Number(rfq_services[i]["service_price"]) *
            Number(rfq_services[i]["quantity"]);
        }
      }
      //Calculate Grand Total
      // API may return camelCase or snake_case field name
      const rawOrderSummaryItems =
        (servicesResponce.data.data[0]["orderSummaryItems"] &&
          servicesResponce.data.data[0]["orderSummaryItems"].length > 0)
          ? servicesResponce.data.data[0]["orderSummaryItems"]
          : (servicesResponce.data.data[0]["order_summary_items"] &&
              servicesResponce.data.data[0]["order_summary_items"].length > 0)
              ? servicesResponce.data.data[0]["order_summary_items"]
              : [];

      const rawOrderSettings =
        servicesResponce.data.data[0]["order_settings"] ||
        servicesResponce.data.data[0]["orderSettings"] ||
        servicesResponce.data["order_settings"] ||
        [];

      const activeOrderSettings = (rawOrderSettings || []).filter(
        (section) => section && section.section_is_active !== false,
      );

      const summaryItemBySectionId = new Map();
      (rawOrderSummaryItems || []).forEach((item) => {
        if (item && item.section_id !== undefined && item.section_id !== null) {
          summaryItemBySectionId.set(item.section_id, item);
        }
      });

      let normalizedOrderSummaryItems = [];
      if (activeOrderSettings.length > 0) {
        let runningTotal = Number(total || 0);
        activeOrderSettings.forEach((section, index) => {
          const existingItem = summaryItemBySectionId.get(section.id);
          const operation = String(
            existingItem?.operation || section.section_type || "ADD",
          ).toUpperCase();
          const scope = String(
            existingItem?.value_type || section.section_scope || "FIXED",
          ).toUpperCase();
          const numericValue = parseFloat(
            existingItem?.value ??
              section.value ??
              section.section_value ??
              section.section_amount ??
              0,
          ) || 0;

          let appliedAmount =
            existingItem?.applied_amount !== undefined &&
            existingItem?.applied_amount !== null
              ? parseFloat(existingItem.applied_amount) || 0
              : 0;

          if (
            (existingItem?.applied_amount === undefined ||
              existingItem?.applied_amount === null) &&
            numericValue > 0
          ) {
            appliedAmount =
              scope === "PERCENTAGE"
                ? (runningTotal * numericValue) / 100
                : numericValue;
          }

          if (appliedAmount > 0) {
            runningTotal =
              operation === "SUBTRACT"
                ? runningTotal - appliedAmount
                : runningTotal + appliedAmount;
          }

          normalizedOrderSummaryItems.push({
            section_id: section.id,
            section_title:
              existingItem?.section_title ||
              section.section_title ||
              section.title ||
              "Summary Item",
            module_type:
              existingItem?.module_type ||
              section.section_module_type ||
              section.module_type ||
              "",
            operation,
            value_type: scope,
            section_order: index,
            value: numericValue,
            description: existingItem?.description || section.description || "",
            applied_amount: appliedAmount,
          });
        });
      } else {
        normalizedOrderSummaryItems = rawOrderSummaryItems;
      }

      let with_discount = total;
      if (normalizedOrderSummaryItems.length > 0) {
        // Use order_summary_items for grand total calculation
        for (let i = 0; i < normalizedOrderSummaryItems.length; i++) {
          const item = normalizedOrderSummaryItems[i];
          const amount = parseFloat(item.applied_amount || item.value || 0);
          const operation = String(item.operation || "").toUpperCase();
          with_discount =
            operation === "SUBTRACT"
              ? with_discount - amount
              : with_discount + amount;
        }
      } else {
        // Fallback to legacy fields
        with_discount = total - parseFloat(discount_value_total);
        with_discount = with_discount + parseFloat(tax_value_total);
        with_discount = with_discount + parseFloat(shipping_value_total);
      }

      //**** Get Optional Services ****/rows_optional
      let servicesOptionalRows = [];
      if (
        servicesResponce.data.data[0]["quote_optional_services"] &&
        servicesResponce.data.data[0]["quote_optional_services"].length > 0
      ) {
        let optional_services =
          servicesResponce.data.data[0]["quote_optional_services"];
        for (let i = 0; i < optional_services.length; i++) {
          let newArrays = {
            id: `row-${i}`,
            data: {
              id: optional_services[i]["service_id"],
              sku: optional_services[i]["sku"],
              name: optional_services[i]["service_name"],
              description: optional_services[i]["description"],
              quantity: optional_services[i]["quantity"],
              unit: optional_services[i]["service_unit"],
              price: Number(optional_services[i]["service_price"]).toFixed(
                generic_decimal
              ),
              total: Number(
                Number(optional_services[i]["quantity"]) *
                optional_services[i]["service_price"]
              ).toFixed(billing_decimal),
              type: optional_services[i]["item_type"],
            },
          };
          servicesOptionalRows.push(newArrays);
        }
      }
      let quote_signature = "";
      if (
        servicesResponce.data.data[0]["quotation_signature"] &&
        servicesResponce.data.data[0]["quotation_signature"] !== ""
      ) {
        quote_signature =
          APP_LIVE_URL +
          "files_data/quotations/" +
          servicesResponce.data.data[0]["quotation_signature"];
      }
      this.setState({
        rows: servicesRows,
        rows_optional: servicesOptionalRows,
        tableData: servicesResponce.data.data,
        quotation_services: servicesResponce.data.data[0]["quote_services"],
        quote_title: servicesResponce.data.data[0]["quote_title"],
        quote_notes: servicesResponce.data.data[0]["quote_notes"],
        quote_attachement: servicesResponce.data.data[0]["quote_attachement"],
        all_answers: servicesResponce.data.all_answers,
        order_summary_items: normalizedOrderSummaryItems,
        service_grand_total:
          with_discount && with_discount > 0 ? with_discount : "0.00",
        service_grand_sub_total: total && total > 0 ? total : "0.00",
        discount_value_total: discount_value_total,
        discount_type: discount_type,
        discount_value: discount_value,
        discount_reason: discount_reason,
        tax_value_total: tax_value_total,
        tax_type: tax_type,
        tax_value: tax_value,
        tax_reason: tax_reason,
        shipping_value_total: shipping_value_total,
        shipping_value: shipping_value,
        shipping_title: shipping_title,
        email_sent: servicesResponce.data.data[0]["email_sent"],
        conversations: servicesResponce.data.data[0]["conversations"],
        quote_status: servicesResponce.data.data[0]["quote_status"],
        quotation_signature: quote_signature,
        tableLoader: false,
        isEditorReady: true,
      });
    } else {
      // window.location.replace("/error");
    }
  };

  getSingleClient = async () => {
    const servicesResponce = await listSingleClient(
      auth.getClientAccount(),
      auth.getClientToken()
    );
    //console.log("getSingleClient: ", servicesResponce.data);
    if (
      servicesResponce.data.status === 403 ||
      servicesResponce.data.errors === "authentication missing" ||
      servicesResponce.data.errors === "jwt expired"
    ) {
      auth.clientLogout();
    } else if (servicesResponce.data.status === 404) {
      //window.location.replace("/error");
      this.setState({ addressLoader: false });
    } else if (
      servicesResponce.data.status === 200 &&
      servicesResponce.data.message === "success"
    ) {
      let bank_transfer_details = "";
      let wire_transfer_details = "";
      if (
        servicesResponce.data.reseller_details.payment_settings &&
        servicesResponce.data.reseller_details.payment_settings.length > 0
      ) {
        let payment_settings =
          servicesResponce.data.reseller_details.payment_settings;
        for (let i = 0; i < payment_settings.length; i++) {
          if (payment_settings[i]["payment_method"] === "bank") {
            bank_transfer_details = payment_settings[i]["payment_details"];
          }
          if (payment_settings[i]["payment_method"] === "wire") {
            wire_transfer_details = payment_settings[i]["payment_details"];
          }
        }
      }
      this.setState({
        client_details: servicesResponce.data.client_details,
        //quotation_notes: quotation_notes,
        //quote_notes: quotation_notes,
        client_name:
          servicesResponce.data.client_details[0]["name"] &&
            servicesResponce.data.client_details[0]["name"] !== ""
            ? servicesResponce.data.client_details[0]["name"]
            : "",
        client_company: servicesResponce.data.client_details[0]["comp_name"]
          ? servicesResponce.data.client_details[0]["comp_name"]
          : "",
        client_email: servicesResponce.data.client_details[0]["email"]
          ? servicesResponce.data.client_details[0]["email"]
          : "",
        client_phone: servicesResponce.data.client_details[0]["phone"]
          ? servicesResponce.data.client_details[0]["phone"]
          : "",
        client_address: servicesResponce.data.client_details[0]["address"]
          ? servicesResponce.data.client_details[0]["address"]
          : "",
        client_address2: servicesResponce.data.client_details[0]["address2"]
          ? servicesResponce.data.client_details[0]["address2"]
          : "",
        client_city: servicesResponce.data.client_details[0]["city"]
          ? servicesResponce.data.client_details[0]["city"]
          : "",
        client_state: servicesResponce.data.client_details[0]["state"]
          ? servicesResponce.data.client_details[0]["state"]
          : "",
        client_zip: servicesResponce.data.client_details[0]["zip"]
          ? servicesResponce.data.client_details[0]["zip"]
          : "",
        client_country: servicesResponce.data.client_details[0]["country"]
          ? servicesResponce.data.client_details[0]["country"]
          : "",
        reseller_details: servicesResponce.data.reseller_details,
        reseller_name: servicesResponce.data.reseller_details
          .reseller_details[0]["name"]
          ? servicesResponce.data.reseller_details.reseller_details[0]["name"]
          : "",
        reseller_company: servicesResponce.data.reseller_details
          .reseller_details[0]["comp_name"]
          ? servicesResponce.data.reseller_details.reseller_details[0][
          "comp_name"
          ]
          : "",
        reseller_email: servicesResponce.data.reseller_details
          .reseller_details[0]["email"]
          ? servicesResponce.data.reseller_details.reseller_details[0]["email"]
          : "",
        reseller_phone: servicesResponce.data.reseller_details
          .reseller_details[0]["phone"]
          ? servicesResponce.data.reseller_details.reseller_details[0]["phone"]
          : "",
        reseller_address: servicesResponce.data.reseller_details
          .reseller_details[0]["address"]
          ? servicesResponce.data.reseller_details.reseller_details[0][
          "address"
          ]
          : "",
        reseller_city: servicesResponce.data.reseller_details
          .reseller_details[0]["city"]
          ? servicesResponce.data.reseller_details.reseller_details[0]["city"]
          : "",
        reseller_state: servicesResponce.data.reseller_details
          .reseller_details[0]["state"]
          ? servicesResponce.data.reseller_details.reseller_details[0]["state"]
          : "",
        reseller_zip: servicesResponce.data.reseller_details
          .reseller_details[0]["zip"]
          ? servicesResponce.data.reseller_details.reseller_details[0]["zip"]
          : "",
        bank_account_details: bank_transfer_details,
        wire_transfer_details: wire_transfer_details,
        bank_account_details_plain:
          bank_transfer_details !== ""
            ? htmlToFormattedText(bank_transfer_details)
            : "",
        wire_transfer_details_plain:
          wire_transfer_details !== ""
            ? htmlToFormattedText(wire_transfer_details)
            : "",
        tableLoader: false,
        addressLoader: false,
      });
    } else {
      // window.location.replace("/error");
      this.setState({ addressLoader: false });
    }
  };

  getQuotationSettings = async (quote_accountno) => {
    const servicesResponce = await getAssignedQuotationSettings(
      auth.getClientAccount(),
      auth.getClientToken(),
      quote_accountno
    );
    // console.log("getQuotationSettings: ", servicesResponce.data);

    if (
      servicesResponce.data.status === 403 ||
      servicesResponce.data.errors === "authentication missing" ||
      servicesResponce.data.errors === "jwt expired"
    ) {
      auth.clientLogout();
    } else if (servicesResponce.data.status === 404) {
      //window.location.replace("/error");
    } else if (
      servicesResponce.data.status === 200 &&
      servicesResponce.data.message === "success"
    ) {
      this.setState({
        payment_terms: servicesResponce.data.data[0]["payment_terms"],
        currency: servicesResponce.data.data[0]["currency"].toUpperCase(),
        contact_person: servicesResponce.data.data[0]["contact_person"],
        contact_email: servicesResponce.data.data[0]["contact_email"],
        validity: servicesResponce.data.data[0]["validity"],
        quote_notes: servicesResponce.data.data[0]["quote_notes"],
        agreement_accountno:
          servicesResponce.data.data[0]["agreement_accountno"],
        agreementTitle: servicesResponce.data.data[0]["agreementTitle"],
        agreementContent: servicesResponce.data.data[0]["agreementContent"],
        tableLoader: false,
      });
    } else {
      // window.location.replace("/error");
    }
  };

  addComment = async () => {
    const { quote_comment, quote_accountno } = this.state;
    this.setState({ quote_comment_button: true, convErrorMessage: "" });
    if (quote_comment !== "") {
      const servicesResponce = await saveQuotationComment(
        auth.getClientAccount(),
        auth.getClientToken(),
        quote_accountno,
        quote_comment
      );
      // console.log("save_quotation_info: ", servicesResponce.data);

      if (
        servicesResponce.data.status === 403 ||
        servicesResponce.data.errors === "authentication missing" ||
        servicesResponce.data.errors === "jwt expired"
      ) {
        auth.clientLogout();
      } else if (servicesResponce.data.status === 404) {
        this.setState({
          convErrorMessage: "There is some error while adding the comment.",
          quote_comment_button: false,
        });
      } else if (
        servicesResponce.data.status === 200 &&
        servicesResponce.data.message === "success"
      ) {
        this.setState({
          conversations: servicesResponce.data.conversations,
          convErrorMessage: "",
          quote_comment_button: false,
          quote_comment: "",
        });
      } else {
        this.setState({
          convErrorMessage: "There is some error while adding the comment.",
          quote_comment_button: false,
        });
      }
    } else {
      this.setState({
        convErrorMessage: "Please enter the comment.",
        quote_comment_button: false,
      });
    }

    setTimeout(() => {
      this.setState({
        convErrorMessage: "",
      });
    }, 4000);
  };

  format_date = (value) => {
    let date = value;
    if (date && date !== "") {
      return dateFormat(date, "mm-dd-yyyy");
    } else {
      return "---";
    }
  };

  fieldValidationUsername = () => {
    let { rfq_comments } = this.state;

    if (rfq_comments === "") {
      this.setState({
        errorMessage: "Customer requirements are required.",
        VerifyBusinessButton: false,
      });
      document
        .getElementById("rfq_Block")
        ?.scrollIntoView({ top: 0, behavior: "smooth" });
      return false;
    } else {
      this.setState({
        errorMessage: "",
        disabled: true,
      });
    }
    return true;
  };

  submitRfq = async () => { };

  handleChangeServices = (idx) => (e) => {
    const { name, value } = e.target;
    const rows = [...this.state.rows];
    const rows_service_temp = [...this.state.rows_service_temp];
    // console.log("services_rows[idx][value]: ", value);
    // console.log("services_rows[idx][name]: ", name);
    // console.log("handleChangeServices rows: ", rows);
    let sub_total = 0;
    if (rows_service_temp) {
      for (let i = 0; i < rows_service_temp.length; i++) {
        // console.log(
        //   "select_service: " + " " + rows_service_temp[i].temp_serv_id
        // );
        if (idx == rows_service_temp[i].temp_serv_id) {
          if (name === "name") {
            rows_service_temp[i].temp_serv_data.temp_serv_inner_name = value;
          }
          if (name === "unit") {
            rows_service_temp[i].temp_serv_data.temp_serv_inner_unit = value;
          }
          if (name === "quantity") {
            rows_service_temp[i].temp_serv_data.temp_serv_inner_quantity =
              value;
            sub_total =
              rows_service_temp[i].temp_serv_data.temp_serv_inner_price *
              parseInt(value);
            rows_service_temp[i].temp_serv_data.temp_serv_inner_total = Number(
              sub_total
            ).toFixed(this.getBillingDecimalPoint());
          }

          if (name === "price") {
            rows_service_temp[i].temp_serv_data.temp_serv_inner_price = value;
            sub_total =
              rows_service_temp[i].temp_serv_data.temp_serv_inner_quantity *
              parseFloat(value);
            rows_service_temp[i].temp_serv_data.temp_serv_inner_total = Number(
              sub_total
            ).toFixed(this.getBillingDecimalPoint());
          }
        }
      }
    } else {
      // console.log("Here1: ");
      this.setState((prevState) => {
        const rows_service_temp = [...prevState.rows_service_temp];
        if (rows_service_temp) {
          rows_service_temp.temp_serv_data[name] = value;
        }
      });
    }
    //Handle Actual Rows
    if (rows) {
      for (let i = 0; i < rows.length; i++) {
        // console.log("select_service: " + " " + rows[i].id);
        if (idx == rows[i].id) {
          if (name === "name") {
            rows[i].data.name = value;
          }
          if (name === "unit") {
            rows[i].data.unit = value;
          }
          if (name === "quantity") {
            rows[i].data.quantity = value;
            sub_total = rows[i].data.price * parseInt(value);
            rows[i].data.total = Number(sub_total).toFixed(
              this.getBillingDecimalPoint()
            );
          }

          if (name === "price") {
            rows[i].data.price = value;
            sub_total = rows[i].data.quantity * parseFloat(value);
            rows[i].data.total = Number(sub_total).toFixed(
              this.getBillingDecimalPoint()
            );
          }
        }
      }
    } else {
      // console.log("Here1: ");
      this.setState((prevState) => {
        const rows = [...prevState.rows];
        if (rows) {
          rows.data[name] = value;
        }
      });
    }

    this.setState({
      rows_service_temp,
      rows,
      isBlocking: false,
    });
    if (name === "quantity" || name === "price") {
      this.calculateTotalRate();
    }
    // console.log("rows_service_temp: ", this.state.rows_service_temp);
    //
  };

  handleChangeCustom = (idx) => (e) => {
    const { name, value } = e.target;
    const rows_custom_temp = [...this.state.rows_custom_temp];
    const rows = [...this.state.rows];
    // console.log("services_rows[idx][value]: ", value);
    // console.log("services_rows[idx][name]: ", name);
    // console.log("handleChangeCustom rows: ", rows_custom_temp);
    let sub_total = 0;
    if (rows_custom_temp) {
      for (let i = 0; i < rows_custom_temp.length; i++) {
        //console.log("select_service: " + " " + rows_custom_temp[i].id);
        if (idx == rows_custom_temp[i].temp_id) {
          if (name === "select_custom_id") {
            rows_custom_temp[i].temp_data.temp_inner_id = value;
          }
          if (name === "select_custom_name") {
            rows_custom_temp[i].temp_data.temp_inner_name = value;
          }
          if (name === "select_custom_unit") {
            rows_custom_temp[i].temp_data.temp_inner_unit = value;
          }
          if (name === "select_custom_quantity") {
            rows_custom_temp[i].temp_data.temp_inner_quantity = value;
            sub_total =
              rows_custom_temp[i].temp_data.temp_inner_price * parseInt(value);
            rows_custom_temp[i].temp_data.temp_inner_total = sub_total;
          }

          if (name === "select_custom_price") {
            rows_custom_temp[i].temp_data.temp_inner_price = value;
            sub_total =
              rows_custom_temp[i].temp_data.temp_inner_quantity *
              parseFloat(value);
            rows_custom_temp[i].temp_data.temp_inner_total = sub_total;
          }
        }
      }
    } else {
      // console.log("Here1: ");
      this.setState((prevState) => {
        const rows_custom_temp = [...prevState.rows_custom_temp];
        if (rows_custom_temp) {
          rows_custom_temp.data[name] = value;
        }
      });
    }

    this.setState({
      rows_custom_temp,
      isBlocking: false,
    });

    if (name === "select_custom_quantity" || name === "select_custom_price") {
      if (rows) {
        for (let i = 0; i < rows.length; i++) {
          if (idx == rows[i].id) {
            if (rows[i].data.name !== "" && rows[i].data.id !== "") {
              if (name === "select_custom_id") {
                rows[i].data.id = value;
              }
              if (name === "select_custom_name") {
                rows[i].data.name = value;
              }
              if (name === "select_custom_unit") {
                rows[i].data.unit = value;
              }
              if (name === "select_custom_quantity") {
                rows[i].data.quantity = value;
                sub_total = rows[i].data.price * parseInt(value);
                rows[i].data.total = sub_total;
              }

              if (name === "select_custom_price") {
                rows[i].data.price = value;
                sub_total = rows[i].data.quantity * parseFloat(value);
                rows[i].data.total = sub_total;
              }
            }
          }
        }
        setTimeout(() => {
          this.calculateTotalRate();
        }, 500);
      }
    }

    // console.log("this.state.rows_custom_temp: ", this.state.rows_custom_temp);
  };

  handleChangeServicesOptional = (idx) => (e) => {
    const { name, value } = e.target;
    const rows_optional = [...this.state.rows_optional];

    let sub_total = 0;
    if (rows_optional) {
      for (let i = 0; i < rows_optional.length; i++) {
        // console.log("select_service: " + " " + rows_optional[i].id);
        if (idx == rows_optional[i].id) {
          if (name === "name") {
            rows_optional[i].data.name = value;
          }
          if (name === "unit") {
            rows_optional[i].data.unit = value;
          }
          if (name === "quantity") {
            rows_optional[i].data.quantity = value;
            sub_total = rows_optional[i].data.price * parseInt(value);
            rows_optional[i].data.total = Number(sub_total).toFixed(
              this.getBillingDecimalPoint()
            );
          }

          if (name === "price") {
            rows_optional[i].data.price = value;
            sub_total = rows_optional[i].data.quantity * parseFloat(value);
            rows_optional[i].data.total = Number(sub_total).toFixed(
              this.getBillingDecimalPoint()
            );
          }
        }
      }
    } else {
      // console.log("Here1: ");
      this.setState((prevState) => {
        const rows_optional = [...prevState.rows_optional];
        if (rows_optional) {
          rows_optional.data[name] = value;
        }
      });
    }

    this.setState({
      rows_optional,
      isBlocking: false,
    });

    // console.log("services_rows: ", this.state.rows_optional);
    //
  };

  calculateTotalRate = async () => {
    const { rows, discount_value_total } = this.state;

    // console.log("calculateTotalRate: ", rows);
    let total = 0;

    if (rows && rows.length > 0) {
      for (let i = 0; i < rows.length; i++) {
        total =
          total + Number(rows[i].data.price) * Number(rows[i].data.quantity);
      }
    }
    // console.log("calculateTotalRate Total: ", total);
    let with_discount = total - parseFloat(discount_value_total);
    //Calculate Tax
    let tax_value_total = this.state.tax_value_total;
    with_discount = with_discount + parseFloat(tax_value_total);
    //Calculate Shipping
    let shipping_value_total = this.state.shipping_value_total;
    with_discount = with_discount + parseFloat(shipping_value_total);

    //Calculate Shipping and Discount

    //with_discount = with_discount + total_tax;
    console.table({
      with_discount_shipping_tax: with_discount,
      discount_value_total: discount_value_total,
      tax_value_total: tax_value_total,
      shipping_value_total: shipping_value_total,
    });
    // console.log("service_grand_sub_total: ", total);
    // console.log("service_grand_total: ", with_discount);
    this.setState({
      service_grand_total:
        with_discount && with_discount > 0
          ? with_discount.toFixed(this.getBillingDecimalPoint())
          : "0.00",
      service_grand_sub_total:
        total && total > 0
          ? total.toFixed(this.getBillingDecimalPoint())
          : "0.00",
    });
  };

  handleChangeRfq = (idx) => (e) => {
    const { rfq_questions_rows } = this.state;
    const { name, value } = e.target;

    let selected_key = name;
    if (rfq_questions_rows && rfq_questions_rows.length > 0) {
      for (let i = 0; i < rfq_questions_rows.length; i++) {
        var mm = Object.entries(rfq_questions_rows[i]);
        //console.log("rfq_questions_rows[i].names: "+rfq_questions_rows[i].some(item => item.key === keyToCheck););
        if (selected_key in rfq_questions_rows[i]) {
          if (value !== "") {
            rfq_questions_rows[i][selected_key] = value;
            rfq_questions_rows[i].question_answered = true;
          }
        }
      }
    }

    this.setState({
      rfq_questions_rows: rfq_questions_rows,
    });
    //
  };

  handleEditorChange = (content, editor) => {
    this.setState({
      rfq_comments: content,
    });
    //console.log("Content was updated:", content);
  };

  handleFileChange = (e) => {
    const selectedFile = e.target.files[0];

    if (!selectedFile) {
      return; // No file selected
    }

    // File type validation selectedFiles
    const allowedFileTypes = [
      ".png",
      ".jpg",
      ".jpeg",
      ".pdf",
      ".doc",
      ".docx",
      ".csv",
      ".xlxs",
      ".xls",
    ];
    const fileExtension = selectedFile.name.split(".").pop().toLowerCase();

    if (!allowedFileTypes.includes(`.${fileExtension}`)) {
      this.setState({
        docErrorMessage:
          "Invalid file type. Please select a valid file format.",
      });
      return;
    }

    // File size validation (e.g., limit to 5MB)
    const maxSizeBytes = 5 * 1024 * 1024; // 5MB
    if (selectedFile.size > maxSizeBytes) {
      this.setState({
        docErrorMessage:
          "File size exceeds the limit (5MB). Please choose a smaller file.",
      });
      return;
    }

    // Clear any previous errors
    this.setState({
      add_picture: selectedFile,
      docErrorMessage: "",
      add_picture_name: selectedFile.name,
    });
    //return true;
  };

  handleChange = (event) => {
    const { target } = event;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const { name } = target;

    this.setState({
      [name]: value,
    });
  };

  addMenuHistory = (link) => {
    this.props.props.history.push(link);
  };

  openSignAndPay = async () => {
    const { quote_accountno, all_services, quotation_services } = this.state;
    this.setState({
      show_signature: false,
      errorMessagePay: "",
      errorMessagePayTitle: "",
      successMessagePay: "",
      copied: false,
    });
    // console.log("all_services: ", all_services);
    // console.log("quotation_services: ", quotation_services);
    //GET AGREEMENT SETTINGS
    const servicesResponce = await getUnSignedServiceAgreements(
      auth.getClientAccount(),
      auth.getClientToken(),
      quote_accountno,
      JSON.stringify(all_services),
      JSON.stringify(quotation_services)
    );
    // console.log("getUnSignedServiceAgreements: ", servicesResponce.data);

    if (
      servicesResponce.data.status === 403 ||
      servicesResponce.data.errors === "authentication missing" ||
      servicesResponce.data.errors === "jwt expired"
    ) {
      auth.clientLogout();
    } else if (servicesResponce.data.status === 404) {
      //window.location.replace("/error");
    } else if (
      servicesResponce.data.status === 200 &&
      servicesResponce.data.message === "success"
    ) {
      this.setState({
        unsignedArray: servicesResponce.data.servicesWithAgreement,
      });
    } else {
      // window.location.replace("/error");
    }
    //this.setState({signatureText: });
    window.$("#modalSignAndPay").modal("show");
    setTimeout(() => {
      this.setState({ show_signature: true });
    }, 2000);
  };

  updateSignatureType = (type) => {
    this.setState({
      signature_type: type,
    });
  };

  handleSignature = (family) => {
    this.setState({ signatureClass: family });
  };

  clear = () => {
    this.signaturePad.clear();
    $("#divImgSig").hide();
    $(".clsimgSig").attr("src", "");
    $(".clsimgSig").hide();
  };

  getServiceWithId = async (select_service) => {
    const { all_services } = this.state;
    // console.log("all_services: ", all_services);
    if (all_services && all_services.length > 0) {
      for (let i = 0; i < all_services.length; i++) {
        // console.log(
        //   "select_service: " + select_service + " " + all_services[i][0]
        // );
        if (select_service == all_services[i][0]) {
          return all_services[i];
        }
      }
    }
  };

  formatPhoneNumber = (phoneNumber) => {
    const phoneNumberObj = parsePhoneNumberFromString(phoneNumber);
    if (phoneNumberObj) {
      if (phoneNumberObj.country === "US") {
        const nationalNumber = phoneNumberObj
          .formatNational()
          .replace(/\D/g, ""); // e.g. "2123727200"
        const areaCode = nationalNumber.slice(0, 3);
        const firstPart = nationalNumber.slice(3, 6);
        const secondPart = nationalNumber.slice(6);
        return `(${areaCode}) ${firstPart}-${secondPart}`;
      }
      return phoneNumberObj.formatInternational();
    }
    return phoneNumber; // Return original number if parsing fails
  };

  addToCart = async (service_id) => {
    const { all_services, rows } = this.state;
    this.setState({
      service_already_eists_message: "",
      service_success_message: "",
    });
    // console.log("addToCart service_id: ", service_id);
    //Check if service exists
    let service_exists = false;
    for (let i = 0; i < rows.length; i++) {
      if (rows[i].data.id === service_id) {
        service_exists = true;
      }
    }
    if (service_exists === true) {
      this.setState({
        service_already_eists_message: "Product already exists in our cart.",
      });
      window.$("#modalAlertCart").modal("show");
    } else {
      let selected_service_row = await this.getServiceWithId(service_id);
      if (selected_service_row) {
        const newRow = {
          id: `row-${Date.now()}`,
          data: {
            id: selected_service_row[0],
            sku:
              selected_service_row[9] && selected_service_row[9] !== ""
                ? selected_service_row[9]
                : "---",
            name: selected_service_row[1],
            quantity: 1,
            unit: "",
            price: selected_service_row[8],
            total: Number(selected_service_row[8] * 1).toFixed(
              this.getBillingDecimalPoint()
            ),
            type: "service",
          },
        };

        this.setState((prevState) => ({
          rows: [...prevState.rows, newRow],
          service_success_message: "Product successfully added to the cart.",
        }));
        let all_select_services = this.state.rows_optional;
        // console.log("all_select_services Optional: ", all_select_services);
        if (all_select_services && all_select_services.length > 0) {
          all_select_services = all_select_services.filter(
            (item) => item.data.id !== service_id
          );

          this.setState({
            rows_optional: all_select_services,
          });
        }

        setTimeout(() => {
          this.calculateTotalRate();
        }, 500);
        window.$("#modalAlertCartSuccess").modal("show");
        // console.log("addToCart selected_service_row: ", selected_service_row);
      } else {
        this.setState({
          service_already_eists_message: "Product does not exist.",
        });
        window.$("#modalAlertCart").modal("show");
      }
    }
  };

  scrollToDiv = (cont_id) => {
    const button = document.getElementById("feedbackButton"); // Replace with the actual ID of your button
    const targetDiv = document.getElementById(cont_id); // Replace with the actual ID of your target div

    if (button && targetDiv) {
      const buttonPosition =
        button.getBoundingClientRect().top + window.scrollY;
      const targetPosition = targetDiv.offsetTop;

      const scroll = () => {
        const currentPosition = window.scrollY;
        const distance = targetPosition - buttonPosition;

        const easeOutCubic = (t) => t * (2 - t);

        const duration = 800; // Adjust the duration as needed
        let start = null;

        const step = (timestamp) => {
          if (!start) start = timestamp;

          const progress = timestamp - start;
          const percentage = progress / duration;

          window.scrollTo(
            0,
            currentPosition + distance * easeOutCubic(percentage)
          );

          if (progress < duration) {
            window.requestAnimationFrame(step);
          }
        };

        window.requestAnimationFrame(step);
      };

      scroll();
    }
  };

  moveToPayment = async () => {
    this.setState({ final_form_step: "payment", show_signature: false });
  };

  moveToSignature = async () => {
    this.setState({ final_form_step: "signature", show_signature: true });
  };

  saveSignature = async () => {
    const { quote_accountno } = this.state;
    let quotation_type = "";
    if (this.state.agreementTitle && this.state.agreementTitle !== "") {
      quotation_type = "agreement quotation";
    } else {
      quotation_type = "no agreement quotation";
    }
    if (this.signaturePad.isEmpty() && this.state.signature_type === "draw") {
      this.setState({
        errorMessagePayTitle: "Missing Fields",
        errorMessagePay: "Please draw the signature to proceed.",
      });
      setTimeout(() => {
        this.setState({
          errorMessagePay: "",
          errorMessagePayTitle: "",
          successMessagePay: "",
          show_signature: false,
        });
      }, 4000);
    } else if (
      this.state.signature_type === "choose" &&
      this.state.signatureText == ""
    ) {
      window.$("#modalAlertError").modal("show");
      this.setState({
        errorMessagePayTitle: "Missing Fields",
        errorMessagePay: "Please enter the authorized person name.",
      });
      setTimeout(() => {
        this.setState({
          errorMessagePay: "",
          errorMessagePayTitle: "",
          successMessagePay: "",
          show_signature: false,
        });
      }, 4000);
    } else {
      this.setState({ finalPayButton: true });
      if (this.state.signature_type === "choose") {
        this.submitSignatoryDetails();
      } else if (this.state.signature_type === "draw") {
        var data = this.signaturePad
          .getTrimmedCanvas()
          .toDataURL("image/svg+xml");
        const apiData = await saveQuotationSignature(
          auth.getClientAccount(),
          auth.getClientToken(),
          data,
          quote_accountno,
          quotation_type,
          this.state.agreement_accountno
        );
        // console.log("MSA: ", apiData.data);
        if (
          apiData.data.status === 403 ||
          apiData.data.errors === "authentication missing" ||
          apiData.data.errors === "jwt expired"
        ) {
          auth.clientLogout();
        } else if (apiData.data.status === 404) {
          this.setState({
            errorMessage: "We are sorry, something went wrong try later.",
            errorMessagePayTitle: "Draw Signature Error",
            finalPayButton: false,
            show_signature: false,
          });
          // this.props.mainHistory.history.push("/error");
          // console.log("errors: ", apiData.data);
        } else if (
          apiData.data.status === 200 &&
          apiData.data.data === "success"
        ) {
          let quote_signature = "";
          if (
            apiData.data.quotation_signature &&
            apiData.data.quotation_signature !== ""
          ) {
            quote_signature =
              APP_LIVE_URL +
              "files_data/quotations/" +
              apiData.data.quotation_signature;
          }
          this.setState({
            errorMessagePay: "",
            errorMessagePayTitle: "",
            successMessagePay: "Signature saved successfully",
            finalPayButton: false,
            final_form_step: "payment",
            quotation_signature: quote_signature,
            show_signature: false,
          });
        }
        setTimeout(() => {
          this.setState({
            errorMessagePay: "",
            errorMessagePayTitle: "",
            successMessagePay: "",
          });
        }, 4000);
      }
    }
  };

  saveAsImage = async () => {
    let {
      signatureText,
      signature_type,
      quote_accountno,
      agreement_accountno,
    } = this.state;
    let quotation_type = "";
    if (this.state.agreementTitle && this.state.agreementTitle !== "") {
      quotation_type = "agreement quotation";
    } else {
      quotation_type = "no agreement quotation";
    }
    const element = document.getElementById("styled-text-container");
    // console.log("element: ", element);
    if (element) {
      html2canvas(element, { scale: 2, backgroundColor: null }).then(
        async (canvas) => {
          const imgData = canvas.toDataURL("image/png");

          const apiData = await saveChooseQuotationSignature(
            auth.getClientAccount(),
            auth.getClientToken(),
            imgData,
            signatureText,
            signature_type,
            quote_accountno,
            quotation_type,
            agreement_accountno
          );
          // console.log("saveSignature: ", apiData.data);
          if (
            apiData.data.status === 403 ||
            apiData.data.errors === "authentication missing" ||
            apiData.data.errors === "jwt expired"
          ) {
            auth.clientLogout();
          } else if (apiData.data.status === 404) {
            this.setState({
              errorMessagePay:
                "There is some error while processing your request.",
              errorMessagePayTitle: "Choose Signature Error",
              successMessagePay: "",
              finalPayButton: false,
              disabled: false,
              show_signature: false,
            });
          } else if (
            apiData.data.status === 200 &&
            apiData.data.data === "success"
          ) {
            //window.location.replace("/" + auth.getResellerRegToken() + "/client/Quotations");
            let quote_signature = "";
            if (
              apiData.data.quotation_signature &&
              apiData.data.quotation_signature !== ""
            ) {
              quote_signature =
                APP_LIVE_URL +
                "files_data/quotations/" +
                apiData.data.quotation_signature;
            }
            this.setState({
              errorMessagePay: "",
              errorMessagePayTitle: "",
              successMessagePay: "Signature saved successfully",
              finalPayButton: false,
              final_form_step: "payment",
              quotation_signature: quote_signature,
              show_signature: false,
            });
          } else {
            this.setState({
              errorMessagePay:
                "There is some error while processing your request.",
              errorMessagePayTitle: "Choose Signature Error",
              successMessagePay: "",
              finalPayButton: false,
              disabled: false,
              show_signature: false,
            });
          }
        }
      );
    }
    setTimeout(() => {
      this.setState({
        errorMessagePay: "",
        errorMessagePayTitle: "",
        successMessagePay: "",
      });
    }, 4000);
  };

  submitSignatoryDetails = async () => {
    let { signatureText, signature_type } = this.state;

    if (signature_type === "choose") {
      await this.saveAsImage();
    }
  };

  saveSalesOrder = async () => {
    const {
      quote_accountno,
      quotation_signature,
      payment_method,
      bank_account_details,
      wire_transfer_details,
      rows,
      discount_type,
      discount_value,
      discount_value_total,
      discount_reason,
      shipping_title,
      shipping_value,
      shipping_value_total,
      tax_type,
      tax_value,
      tax_value_total,
      tax_reason,
      service_grand_sub_total,
      service_grand_total,
    } = this.state;
    this.setState({ finalPayButton: true });
    // console.log(
    //   "service_grand_sub_total service_grand_total: " +
    //     service_grand_sub_total +
    //     " " +
    //     service_grand_total
    // );
    const apiData = await saveSalesOrder(
      auth.getClientAccount(),
      auth.getClientToken(),
      quotation_signature,
      payment_method,
      bank_account_details,
      wire_transfer_details,
      quote_accountno,
      JSON.stringify(rows),
      discount_type,
      discount_value,
      discount_value_total,
      discount_reason,
      shipping_title,
      shipping_value,
      shipping_value_total,
      tax_type,
      tax_value,
      tax_value_total,
      tax_reason,
      service_grand_sub_total,
      service_grand_total
    );
    // console.log("saveSalesOrder: ", apiData.data);
    if (
      apiData.data.status === 403 ||
      apiData.data.errors === "authentication missing" ||
      apiData.data.errors === "jwt expired"
    ) {
      auth.clientLogout();
    } else if (apiData.data.status === 404) {
      this.setState({
        errorMessagePay: "There is some error while processing your request.",
        errorMessagePayTitle: "Sales Order Error",
        successMessagePay: "",
        finalPayButton: false,
        disabled: false,
        show_signature: false,
      });
    } else if (
      apiData.data.status === 200 &&
      apiData.data.message === "success"
    ) {
      //window.location.replace("/" + auth.getResellerRegToken() + "/client/Quotations");
      let quote_signature = "";
      if (
        apiData.data.quotation_signature &&
        apiData.data.quotation_signature !== ""
      ) {
        quote_signature =
          APP_LIVE_URL +
          "files_data/quotations/" +
          apiData.data.quotation_signature;
      }
      this.setState({
        errorMessagePay: "",
        errorMessagePayTitle: "",
        successMessagePay: "Sales order created successfully.",
      });
      setTimeout(() => {
        window.location.replace(
          "/" + auth.getResellerRegToken() + "/client/SalesOrders"
        );
      }, 3000);
    } else {
      this.setState({
        errorMessagePay: "There is some error while processing your request.",
        errorMessagePayTitle: "Sales Order Error",
        successMessagePay: "",
        finalPayButton: false,
        disabled: false,
        show_signature: false,
      });
    }
    setTimeout(() => {
      this.setState({
        errorMessagePay: "",
        errorMessagePayTitle: "",
        successMessagePay: "",
      });
    }, 4000);
  };

  handleChangeCheckbox = async (event) => {
    const { target } = event;
    const value = target.type === "radio" ? target.value : target.value;
    const { name } = target;

    this.setState({
      [name]: value,
      isBlocking: false,
      copied: false,
    });

    // console.log("handleChangeCheckbox:", name + " " + value);
  };

  downloadPdfView = async (d_f_name) => {
    this.setState({ quote_attachement_button: true });
    var url = d_f_name;
    let file_name = "";
    let check_url = this.isStringURL(url);
    // console.log("check_url: " + check_url + " " + url);
    if (check_url === true) {
      file_name = this.getFileNameFromUrl(url);
    } else {
      file_name = url;
      url = APP_LIVE_URL + "files_data/rfq/" + url;
    }

    fetch(url)
      .then((x) => x.blob())
      .then((b) => {
        // console.log("B INSTANCE", b instanceof Blob);
        const url = window.URL.createObjectURL(b);
        var a = document.createElement("a");
        document.body.appendChild(a);
        a.style = "display: none";
        a.href = url;
        a.download = file_name;
        a.click();
        window.URL.revokeObjectURL(url);
        this.setState({
          errorMessage: "",
          quote_attachement_button: false,
        });
      })
      .catch((error) => {
        this.setState({
          errorMessage: "There is some error while downloading the attachment.",
          quote_attachement_button: false,
        });
        setTimeout(() => {
          this.setState({ errorMessage: "" });
        }, 4000);
        // Handle any errors that occurred during the fetch
        console.error("Fetch error:", error);
      });
  };

  getFileNameFromUrl = (url) => {
    try {
      const urlObject = new URL(url);
      // Using the pathname for simplicity; adjust as needed based on your URL structure
      const fileName = urlObject.pathname.split("/").pop();
      return fileName;
    } catch (error) {
      console.error("Error extracting file name:", error);
      return "attachement";
    }
  };

  isStringURL = (str) => {
    try {
      new URL(str);
      return true;
    } catch (error) {
      return false;
    }
  };

  rejectQuotation = async () => {
    const { quote_accountno } = this.state;
    this.setState({
      rejection_reason: "",
      rejectErrorMessage: "",
      rejectSuccessMessage: "",
    });
    window.$("#modalRejectQuotation").modal("show");
  };

  rejectQuotationSubmit = async () => {
    const { quote_accountno, rejection_reason } = this.state;
    this.setState({
      rejectionButton: true,
      rejectErrorMessage: "",
      rejectSuccessMessage: "",
    });
    if (rejection_reason === "") {
      this.setState({
        rejectErrorMessage: "Please enter the reason.",
        rejectErrorMessageTitle: "Missing Fields",
      });
    } else {
      const rejectionResponse = await rejectQuotation(
        auth.getClientAccount(),
        auth.getClientToken(),
        quote_accountno,
        rejection_reason
      );
      // console.log("rejectionResponse: ", rejectionResponse.data);
      if (
        rejectionResponse.data.status === 403 ||
        rejectionResponse.data.errors === "authentication missing" ||
        rejectionResponse.data.errors === "jwt expired"
      ) {
        auth.clientLogout();
      } else if (
        rejectionResponse.data.status === 404 &&
        rejectionResponse.data.message === "not_found"
      ) {
        this.setState({
          rejectErrorMessage: "Quotation not found.",
          rejectErrorMessageTitle: "Missing Quotation",
          rejectSuccessMessage: "",
          rejectionButton: false,
        });
      } else if (
        rejectionResponse.data.status === 200 &&
        rejectionResponse.data.message === "success"
      ) {
        this.setState({
          rejectErrorMessage: "",
          rejectErrorMessageTitle: "Rejection Error",
          rejectSuccessMessage: "Quotation rejected successfully.",
          rejectionButton: false,
        });
        setTimeout(() => {
          window.location.reload();
        }, 3000);
      } else {
        this.setState({
          rejectErrorMessage:
            "There is some error while processing your request.",
          rejectErrorMessageTitle: "Sales Order Error",
          rejectSuccessMessage: "",
          rejectionButton: false,
        });
      }
      setTimeout(() => {
        this.setState({
          rejectErrorMessage: "",
          rejectErrorMessageTitle: "",
          rejectSuccessMessage: "",
        });
      }, 4000);
    }
  };

  formatAsCurrencys = (amount) => {
    // console.log("amount: ", typeof amount);
    let decimal_point = this.getBillingDecimalPoint();

    if (typeof amount === "string") {
      amount = parseFloat(amount);
    }
    return amount.toLocaleString("en-US", {
      style: "currency",
      currency: "USD",
      minimumFractionDigits: decimal_point,
      maximumFractionDigits: decimal_point,
    });
  };

  formatAsCurrencysSimple = (amount) => {
    // console.log("amount: ", typeof amount);
    let decimal_point = this.getDecimalPoint();

    if (typeof amount === "string") {
      amount = parseFloat(amount);
    }
    return amount.toLocaleString("en-US", {
      style: "currency",
      currency: "USD",
      minimumFractionDigits: decimal_point,
      maximumFractionDigits: decimal_point,
    });
  };

  // Validation helper: Check if order summary items are available
  hasValidOrderSummaryData = () => {
    const { order_summary_items } = this.state;
    const items = order_summary_items || [];

    return items.length > 0;
  };

  render() {
    //$(".nk-block .MUIDataTable-paper-2").css("padding", "10px");
    const fetchToken = async () => {
      try {
        const response = await fetch(
          API_URL + "agents/editor_token_url_clients",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              request_type: "ckeditor-tokenUrl",
              user: auth.getClientAccount(),
            }),
          }
        );
        const data = await response.json();
        return data.token;
      } catch (error) {
        console.error("Failed to fetch token:", error);
        return null;
      }
    };
    return (
      <div className="nk-content rfq_Block" id="editQuotations">
        <div className="container-fluid">
          {this.props.defaultSettings === "missing" &&
            this.props.from !== "dashboard" ? (
            <SettingsError />
          ) : null}
          {/* MSA WARNING  START*/}
          {this.props.is_msa_signed === "No" &&
            this.props.from !== "dashboard" ? (
            <MsaWarning />
          ) : null}

          {/* MSA WARNING END */}

          <div className="nk-content-inner">
            <div className="nk-content-body">
              {/* PAGE TITLE START */}
              <div className="nk-block-head nk-block-head-sm">
                <div className="nk-block-between">
                  <div className="nk-block-head-content">
                    <Breadcrumbs aria-label="breadcrumb">
                      <Link
                        color="inherit"
                        onClick={() =>
                          this.addMenuHistory(
                            "/" + auth.getResellerRegToken() + "/client/"
                          )
                        }
                        className=""
                        style={{
                          display: "flex",
                          alignItems: "center",
                          cursor: "pointer",
                        }}
                      >
                        <HomeIcon fontSize="inherit" className="" />
                        Home
                      </Link>
                      <Link
                        color="inherit"
                        onClick={() =>
                          this.addMenuHistory(
                            "/" +
                            auth.getResellerRegToken() +
                            "/client/Quotations"
                          )
                        }
                        className=""
                        style={{
                          display: "flex",
                          alignItems: "center",
                          cursor: "pointer",
                        }}
                      >
                        Quotations
                      </Link>

                      <Typography color="textPrimary" className="">
                        Quotation Details
                      </Typography>
                    </Breadcrumbs>
                  </div>
                  {/* <div className="nk-block-head-content" id="HeadContent">
                    <div className="toggle-wrap nk-block-tools-toggle">
                      <a
                        href="#"
                        className="btn btn-icon btn-trigger toggle-expand mr-n1"
                        data-target="pageMenu"
                      >
                        <em className="icon ni ni-more-v"></em>
                      </a>
                    </div>
                  </div> */}
                </div>
              </div>
              {/* PAGE TITLE END */}
              <div className="row g-gs">
                {/* Table 5th Col Start */}
                <div className="col-xxl-12">
                  {this.state.errorMessage !== "" ? (
                    <div
                      className="example-alert"
                      style={{ marginBottom: "15px" }}
                    >
                      <div className="alert alert-pro alert-danger">
                        <div className="alert-text">
                          <h4>Error</h4>
                          <p>{this.state.errorMessage}</p>
                        </div>
                      </div>
                    </div>
                  ) : null}
                  {this.state.successMessage !== "" ? (
                    <div
                      className="example-alert"
                      style={{ marginBottom: "15px" }}
                    >
                      <div className="alert alert-pro alert-success">
                        <div className="alert-text">
                          <h4>Success</h4>
                          <p>{this.state.successMessage}</p>
                        </div>
                      </div>
                    </div>
                  ) : null}
                  <div className="card card-bordered">
                    <div className="card-inner">
                      <div className="p-2">
                        <ul className="d-flex flex-column flex-sm-row justify-end g-2 w-100 w-sm-auto">
                          <li>
                            {this.state.quote_attachement_button === true ? (
                              <button
                                className="btn btn-primary"
                                type="button"
                                disabled
                              >
                                <span
                                  className="spinner-border spinner-border-sm"
                                  role="status"
                                  aria-hidden="true"
                                ></span>
                                <span> downloading... </span>
                              </button>
                            ) : (
                              <a
                                onClick={() =>
                                  this.downloadPdfView(
                                    this.state.quote_attachement
                                  )
                                }
                                className="btn btn-info"
                                style={{ color: "#fff", cursor: "pointer", width: "100%", justifyContent: "center"}}
                              >
                                <em className="icon ni ni-download"></em>{" "}
                                <span>Download</span>{" "}
                              </a>
                            )}
                          </li>

                          <li>
                            <a
                              onClick={() =>
                                this.scrollToDiv("feedbackContainer")
                              }
                              style={{ color: "#fff", width: "100%", justifyContent: "center" }}
                              className="btn btn-secondary"
                              id="feedbackButton"
                            >
                              <em className="icon ni ni-chat"></em>{" "}
                              <span>Feedback</span>{" "}
                            </a>
                          </li>

                          {this.state.quote_status !== "" &&
                            this.state.quote_status !== "completed" &&
                            this.state.quote_status !== "cancelled" ? (
                            <>
                              <li>
                                <a
                                  onClick={() => this.rejectQuotation()}
                                  className="btn btn-danger"
                                  style={{ cursor: "pointer", color: "#fff", width: "100%", justifyContent: "center" }}
                                >
                                  <em className="icon ni ni-cross-round"></em>{" "}
                                  <span>Reject</span>{" "}
                                </a>
                              </li>

                              <li>
                                <a
                                  onClick={() => this.openSignAndPay()}
                                  style={{ cursor: "pointer", color: "#fff", width: "100%", justifyContent: "center" }}
                                  className="btn btn-success"
                                >
                                  <em className="icon ni ni-check-round-cut"></em>{" "}
                                  <span>Sign & Pay</span>{" "}
                                </a>
                              </li>
                            </>
                          ) : null}
                        </ul>
                      </div>
                      <div className="invoice mt-4">
                        <div className="invoice-wrap">
                          <div className="invoice-head">
                            {this.state.addressLoader === true ? (
                              CheckboxList()
                            ) : (
                              <div className="invoice-contact">
                                <span className="overline-title text-dark">
                                  Quotation To
                                </span>
                                <div className="invoice-contact-info">
                                  <h4 className="title text-dark">
                                    {this.state.client_company}
                                  </h4>
                                  <ul className="list-plain">
                                    {this.state.client_address &&
                                      this.state.client_address !== "" ? (
                                      <li>
                                        <em className="icon ni ni-map-pin-fill"></em>
                                        <span className="text-dark">
                                          {this.state.client_address &&
                                            this.state.client_address !== ""
                                            ? this.state.client_address
                                            : ""}
                                          {this.state.client_address2 &&
                                            this.state.client_address2 !== ""
                                            ? this.state.client_address2
                                            : ""}
                                          <br />
                                          {this.state.client_city &&
                                            this.state.client_city !== ""
                                            ? this.state.client_city
                                            : ""}{" "}
                                          {this.state.client_state &&
                                            this.state.client_state !== ""
                                            ? this.state.client_state
                                            : ""}{" "}
                                          {this.state.client_zip &&
                                            this.state.client_zip !== ""
                                            ? this.state.client_zip
                                            : ""}{" "}
                                          {this.state.client_country &&
                                            this.state.client_country !== ""
                                            ? this.state.client_country
                                            : ""}
                                        </span>
                                      </li>
                                    ) : null}
                                    <li>
                                      <em className="icon ni ni-call-fill"></em>
                                      <span className="text-dark">
                                        {this.state.client_phone &&
                                          this.state.client_phone !== ""
                                          ? this.formatPhoneNumber(
                                            this.state.client_phone
                                          )
                                          : "---"}
                                      </span>
                                    </li>
                                  </ul>
                                </div>
                              </div>
                            )}

                            <div className="invoice-desc right_invoice">
                              <h3 className="title">Quotation </h3>
                              <ul className="list-plain">
                                <li className="invoice-id border-bottom">
                                  <span className="text-dark fw-bold">
                                    Quotation No
                                  </span>
                                  :
                                  <span className="text-dark fw-bold">
                                    {this.state.quote_accountno}
                                  </span>
                                </li>
                                <li className="invoice-date border-bottom">
                                  <span className="text-dark">Issue Date</span>:
                                  <span className="text-dark">
                                    {this.format_date(new Date())}
                                  </span>
                                </li>
                                <li className="invoice-date border-bottom">
                                  <span className="text-dark">From</span>:
                                  <span className="text-dark">
                                    {this.state.reseller_company}
                                  </span>
                                </li>
                                <li className="invoice-date border-bottom">
                                  <span className="text-dark">Company</span>:
                                  <span className="text-dark">
                                    {this.state.client_company}
                                  </span>
                                </li>
                                {this.state.payment_terms !== "" ? (
                                  <li className="invoice-date border-bottom">
                                    <span className="text-dark">
                                      Terms of Payment
                                    </span>
                                    :
                                    <span className="text-dark">
                                      {this.state.payment_terms}
                                    </span>
                                  </li>
                                ) : null}
                                {this.state.currency !== "" ? (
                                  <li className="invoice-date border-bottom">
                                    <span className="text-dark">Currency</span>:
                                    <span className="text-dark">
                                      {this.state.currency}
                                    </span>
                                  </li>
                                ) : null}
                                {this.state.contact_person !== "" ? (
                                  <li className="invoice-date border-bottom">
                                    <span className="text-dark">
                                      Contact Person{" "}
                                    </span>
                                    :
                                    <span className="text-dark">
                                      {this.state.contact_person}
                                    </span>
                                  </li>
                                ) : null}
                                {this.state.contact_email !== "" ? (
                                  <li className="invoice-date border-bottom">
                                    <span className="text-dark">Email</span>:
                                    <span className="text-dark">
                                      {this.state.contact_email}
                                    </span>
                                  </li>
                                ) : null}{" "}
                                {this.state.agreementTitle &&
                                  this.state.agreementTitle !== "" ? (
                                  <li className="invoice-date">
                                    {" "}
                                    <span className="text-dark">
                                      Qoutation Agreement
                                    </span>
                                    :{" "}
                                    <span className="text-dark">
                                      {" "}
                                      {this.state.agreementTitle}{" "}
                                    </span>{" "}
                                  </li>
                                ) : null}
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                      <ul className="nav nav-tabs mt-4">
                        <li className="nav-item">
                          <a
                            className="nav-link active"
                            data-toggle="tab"
                            href="#tabItem5"
                          >
                            <em className="icon ni ni-list-ol"></em>
                            <span>Order Lines</span>
                          </a>
                        </li>

                        {this.state.rfq_accountno &&
                          this.state.rfq_accountno !== "" ? (
                          <li className="nav-item">
                            <a
                              className="nav-link"
                              data-toggle="tab"
                              href="#tabItem8"
                            >
                              <em className="icon ni ni-question-alt"></em>
                              <span>Received RFQ</span>
                            </a>
                          </li>
                        ) : null}
                      </ul>
                      <div className="tab-content">
                        <div className="tab-pane active" id="tabItem5">
                          <div className="row g-gs">
                            <div className="col-xxl-12 inner_content">
                              <div className="invoice">
                                <div className="invoice-wrap">
                                  <div className="invoice-bills">
                                    <div className=" genericTable">
                                      <DragDropContext
                                        onDragEnd={this.handleDragEnd}
                                      >
                                        <Droppable droppableId="droppable-1">
                                          {(provided) => (
                                            <table
                                              ref={provided.innerRef}
                                              {...provided.droppableProps}
                                              className="table table-striped"
                                            >
                                              <thead>
                                                <tr>
                                                  <th
                                                    className="w-5"
                                                    style={{
                                                      paddingLeft: "1.25rem",
                                                    }}
                                                  >
                                                    <em className="icon ni ni-move"></em>
                                                  </th>
                                                  <th className="w-10">
                                                    ITEM ID
                                                  </th>
                                                  <th className="w-10">SKU</th>
                                                  <th className="w-25">
                                                    PRODUCT NAME
                                                  </th>
                                                  <th className="w-10">QTY</th>
                                                  <th className="w-10">UNIT</th>
                                                  <th className="w-10">
                                                    PRICE($)
                                                  </th>
                                                  <th className="w-10">
                                                    TOTAL($)
                                                  </th>
                                                  <th className="w-10">
                                                    &nbsp;
                                                  </th>
                                                </tr>
                                              </thead>
                                              <tbody>
                                                {this.state.rows.map(
                                                  (row, index) => (
                                                    <Draggable
                                                      key={row.id}
                                                      draggableId={`${row.id}-1`}
                                                      index={index}
                                                    >
                                                      {(provided) => (
                                                        <tr
                                                          ref={
                                                            provided.innerRef
                                                          }
                                                          {...provided.draggableProps}
                                                          {...provided.dragHandleProps}
                                                        >
                                                          {row.data.type &&
                                                            row.data.type ===
                                                            "service" ? (
                                                            <>
                                                              <td>
                                                                <em className="icon ni ni-move"></em>
                                                              </td>
                                                              <td>
                                                                {row.data.id &&
                                                                  row.data.id !==
                                                                  ""
                                                                  ? row.data.id
                                                                  : "---"}
                                                              </td>
                                                              <td>
                                                                {row.data.sku &&
                                                                  row.data.sku !==
                                                                  ""
                                                                  ? row.data.sku
                                                                  : "---"}
                                                              </td>
                                                              <td>
                                                                {row.data
                                                                  .name !==
                                                                  "" ? (
                                                                  <div>
                                                                    <div>
                                                                      {row.data
                                                                        .name &&
                                                                        row.data
                                                                          .name !==
                                                                        "" ? (
                                                                        row.data
                                                                          .name
                                                                      ) : (
                                                                        "---"
                                                                      )}
                                                                    </div>
                                                                    {row.data
                                                                      .description &&
                                                                      row.data
                                                                        .description !==
                                                                        "" && (
                                                                        <div
                                                                          style={{
                                                                            fontSize:
                                                                              "0.85em",
                                                                            color:
                                                                              "#666",
                                                                            marginTop:
                                                                              "4px",
                                                                          }}
                                                                        >
                                                                          {
                                                                            row
                                                                              .data
                                                                              .description
                                                                          }
                                                                        </div>
                                                                      )}
                                                                  </div>
                                                                ) : (
                                                                  <Select
                                                                    options={
                                                                      this.state
                                                                        .all_select_services
                                                                    }
                                                                    name={`select_a_service_${index}`}
                                                                    placeholder="Select product / service"
                                                                    value={
                                                                      this
                                                                        .state[
                                                                      `select_a_service_${index}`
                                                                      ]
                                                                    }
                                                                    autoComplete="off"
                                                                    emptyMessage="Product not found"
                                                                    onChange={(
                                                                      select_a_service,
                                                                      { action }
                                                                    ) =>
                                                                      this.handleChangeSearchNew(
                                                                        select_a_service,
                                                                        {
                                                                          action,
                                                                          row,
                                                                          index,
                                                                        }
                                                                      )
                                                                    }
                                                                    isClearable
                                                                    isSearchable
                                                                    components={
                                                                      animatedComponents
                                                                    }
                                                                  />
                                                                )}
                                                              </td>
                                                              <td>
                                                                <div className="form-control-wrap">
                                                                  <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    id="quantity"
                                                                    name="quantity"
                                                                    onChange={this.handleChangeServices(
                                                                      row.id
                                                                    )}
                                                                    placeholder=""
                                                                    style={{
                                                                      width:
                                                                        "60px",
                                                                      textAlign:
                                                                        "center",
                                                                    }}
                                                                    defaultValue={
                                                                      row.data
                                                                        .quantity
                                                                    }
                                                                    maxLength={
                                                                      6
                                                                    }
                                                                    onInput={(
                                                                      e
                                                                    ) => {
                                                                      e.target.value =
                                                                        e.target.value.replace(
                                                                          /[^0-9]/gi,
                                                                          ""
                                                                        );
                                                                    }}
                                                                    required
                                                                    readOnly
                                                                  />
                                                                </div>
                                                              </td>
                                                              <td>
                                                                <div className="form-control-wrap">
                                                                  <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    id="unit"
                                                                    name="unit"
                                                                    onChange={this.handleChangeServices(
                                                                      row.id
                                                                    )}
                                                                    placeholder=""
                                                                    style={{
                                                                      width:
                                                                        "100px",
                                                                      textAlign:
                                                                        "center",
                                                                    }}
                                                                    defaultValue={
                                                                      row.data
                                                                        .unit
                                                                    }
                                                                    maxLength={
                                                                      20
                                                                    }
                                                                    onInput={(
                                                                      e
                                                                    ) => {
                                                                      e.target.value =
                                                                        e.target.value.replace(
                                                                          /[^a-zA-Z0-9 ]/gi,
                                                                          ""
                                                                        );
                                                                    }}
                                                                    required
                                                                    readOnly
                                                                  />
                                                                </div>
                                                              </td>
                                                              <td>
                                                                <div className="form-control-wrap">
                                                                  <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    id="price"
                                                                    name="price"
                                                                    onChange={this.handleChangeServices(
                                                                      row.id
                                                                    )}
                                                                    placeholder=""
                                                                    style={{
                                                                      width:
                                                                        "100px",
                                                                      textAlign:
                                                                        "center",
                                                                    }}
                                                                    defaultValue={
                                                                      row.data
                                                                        .price
                                                                    }
                                                                    readOnly
                                                                    required
                                                                  />
                                                                </div>
                                                              </td>
                                                              <td>
                                                                {this.formatAsCurrencys(
                                                                  Number(
                                                                    row.data
                                                                      .total
                                                                  )
                                                                )}
                                                              </td>
                                                              <td>
                                                                {row.data
                                                                  .name ===
                                                                  "" ? (
                                                                  <span
                                                                    className="badge badge-outline-primary mr-1"
                                                                    onClick={() =>
                                                                      this.addNewService(
                                                                        row.id
                                                                      )
                                                                    }
                                                                    style={{
                                                                      cursor:
                                                                        "pointer",
                                                                      paddingTop:
                                                                        "3px",
                                                                      paddingBottom:
                                                                        "3px",
                                                                      paddingLeft:
                                                                        "7px",
                                                                      fontSize:
                                                                        "18px",
                                                                    }}
                                                                  >
                                                                    <em className="icon ni ni-save"></em>
                                                                  </span>
                                                                ) : null}
                                                                {/*<span
                                                                  className="badge badge-outline-danger"
                                                                  onClick={() =>
                                                                    this.removeRow(
                                                                      row.id
                                                                    )
                                                                  }
                                                                  style={{
                                                                    cursor:
                                                                      "pointer",
                                                                    paddingTop:
                                                                      "3px",
                                                                    paddingBottom:
                                                                      "3px",
                                                                    paddingLeft:
                                                                      "7px",
                                                                    fontSize:
                                                                      "18px",
                                                                  }}
                                                                >
                                                                  <em className="icon ni ni-trash"></em>
                                                                </span>*/}
                                                              </td>
                                                            </>
                                                          ) : row.data.type ===
                                                            "section" ? (
                                                            <>
                                                              <td>
                                                                <em className="icon ni ni-move"></em>
                                                              </td>
                                                              <td
                                                                style={{
                                                                  fontWeight:
                                                                    "bold",
                                                                }}
                                                                colSpan={7}
                                                              >
                                                                {row.data
                                                                  .name &&
                                                                  row.data
                                                                    .name !==
                                                                  "" ? (
                                                                  row.data.name
                                                                ) : (
                                                                  <div className="form-control-wrap">
                                                                    <input
                                                                      type="text"
                                                                      className="form-control"
                                                                      id="select_name"
                                                                      name="select_name"
                                                                      onChange={this.handleChangeSection(
                                                                        row.id
                                                                      )}
                                                                      placeholder=""
                                                                      autoComplete="off"
                                                                      defaultValue={
                                                                        row.data
                                                                          .name
                                                                      }
                                                                      required
                                                                    />
                                                                  </div>
                                                                )}
                                                              </td>
                                                              <td>
                                                                {row.data
                                                                  .name ===
                                                                  "" ? (
                                                                  <span
                                                                    className="badge badge-outline-primary mr-1"
                                                                    onClick={() =>
                                                                      this.addNewSection(
                                                                        row.id
                                                                      )
                                                                    }
                                                                    style={{
                                                                      cursor:
                                                                        "pointer",
                                                                      paddingTop:
                                                                        "3px",
                                                                      paddingBottom:
                                                                        "3px",
                                                                      paddingLeft:
                                                                        "7px",
                                                                      fontSize:
                                                                        "18px",
                                                                    }}
                                                                  >
                                                                    <em className="icon ni ni-save"></em>
                                                                  </span>
                                                                ) : null}
                                                                {/*<span
                                                                  className="badge badge-outline-danger"
                                                                  onClick={() =>
                                                                    this.removeRow(
                                                                      row.id
                                                                    )
                                                                  }
                                                                  style={{
                                                                    cursor:
                                                                      "pointer",
                                                                    paddingTop:
                                                                      "3px",
                                                                    paddingBottom:
                                                                      "3px",
                                                                    paddingLeft:
                                                                      "7px",
                                                                    fontSize:
                                                                      "18px",
                                                                  }}
                                                                >
                                                                  <em className="icon ni ni-trash"></em>
                                                                </span>*/}
                                                              </td>
                                                            </>
                                                          ) : row.data.type ===
                                                            "custom" ? (
                                                            <>
                                                              <td>
                                                                <em className="icon ni ni-move"></em>
                                                              </td>
                                                              <td>
                                                                {row.data.id &&
                                                                  row.data.id !==
                                                                  "" ? (
                                                                  row.data.id
                                                                ) : (
                                                                  <div className="form-control-wrap">
                                                                    <input
                                                                      type="text"
                                                                      className="form-control"
                                                                      id="select_custom_id"
                                                                      name="select_custom_id"
                                                                      onChange={this.handleChangeCustom(
                                                                        row.id
                                                                      )}
                                                                      placeholder=""
                                                                      autoComplete={
                                                                        false
                                                                      }
                                                                      defaultValue={
                                                                        row.data
                                                                          .id
                                                                      }
                                                                      required
                                                                    />
                                                                  </div>
                                                                )}
                                                              </td>
                                                              <td>
                                                                {row.data.sku &&
                                                                  row.data.sku !==
                                                                  "" ? (
                                                                  row.data.sku
                                                                ) : (
                                                                  <div className="form-control-wrap">
                                                                    <input
                                                                      type="text"
                                                                      className="form-control"
                                                                      id="select_custom_sku"
                                                                      name="select_custom_sku"
                                                                      onChange={this.handleChangeCustom(
                                                                        row.id
                                                                      )}
                                                                      placeholder=""
                                                                      autoComplete={
                                                                        false
                                                                      }
                                                                      defaultValue={
                                                                        row.data
                                                                          .sku
                                                                      }
                                                                      required
                                                                    />
                                                                  </div>
                                                                )}
                                                              </td>
                                                              <td>
                                                                {row.data
                                                                  .name !==
                                                                  "" ? (
                                                                  <div>
                                                                    <div>
                                                                      {row.data
                                                                        .name &&
                                                                        row.data
                                                                          .name !==
                                                                        "" ? (
                                                                        row.data
                                                                          .name
                                                                      ) : (
                                                                        "---"
                                                                      )}
                                                                    </div>
                                                                    {row.data
                                                                      .description &&
                                                                      row.data
                                                                        .description !==
                                                                        "" && (
                                                                        <div
                                                                          style={{
                                                                            fontSize:
                                                                              "0.85em",
                                                                            color:
                                                                              "#666",
                                                                            marginTop:
                                                                              "4px",
                                                                          }}
                                                                        >
                                                                          {
                                                                            row
                                                                              .data
                                                                              .description
                                                                          }
                                                                        </div>
                                                                      )}
                                                                  </div>
                                                                ) : (
                                                                  <div className="form-control-wrap">
                                                                    <input
                                                                      type="text"
                                                                      className="form-control"
                                                                      id="select_custom_name"
                                                                      name="select_custom_name"
                                                                      onChange={this.handleChangeCustom(
                                                                        row.id
                                                                      )}
                                                                      placeholder=""
                                                                      autoComplete={
                                                                        false
                                                                      }
                                                                      defaultValue={
                                                                        row.data
                                                                          .name
                                                                      }
                                                                      required
                                                                    />
                                                                  </div>
                                                                )}
                                                              </td>
                                                              <td>
                                                                <div className="form-control-wrap">
                                                                  <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    id="select_custom_quantity"
                                                                    name="select_custom_quantity"
                                                                    onChange={this.handleChangeCustom(
                                                                      row.id
                                                                    )}
                                                                    placeholder=""
                                                                    style={{
                                                                      width:
                                                                        "60px",
                                                                      textAlign:
                                                                        "center",
                                                                    }}
                                                                    defaultValue={
                                                                      row.data
                                                                        .quantity
                                                                    }
                                                                    maxLength={
                                                                      6
                                                                    }
                                                                    onInput={(
                                                                      e
                                                                    ) => {
                                                                      e.target.value =
                                                                        e.target.value.replace(
                                                                          /[^0-9]/gi,
                                                                          ""
                                                                        );
                                                                    }}
                                                                    required
                                                                  />
                                                                </div>
                                                              </td>
                                                              <td>
                                                                <div className="form-control-wrap">
                                                                  <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    id="select_custom_unit"
                                                                    name="select_custom_unit"
                                                                    onChange={this.handleChangeCustom(
                                                                      row.id
                                                                    )}
                                                                    placeholder=""
                                                                    style={{
                                                                      width:
                                                                        "100px",
                                                                      textAlign:
                                                                        "center",
                                                                    }}
                                                                    defaultValue={
                                                                      row.data
                                                                        .unit
                                                                    }
                                                                    maxLength={
                                                                      20
                                                                    }
                                                                    onInput={(
                                                                      e
                                                                    ) => {
                                                                      e.target.value =
                                                                        e.target.value.replace(
                                                                          /[^a-zA-Z0-9 ]/gi,
                                                                          ""
                                                                        );
                                                                    }}
                                                                    required
                                                                  />
                                                                </div>
                                                              </td>
                                                              <td>
                                                                <div className="form-control-wrap">
                                                                  <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    id="select_custom_price"
                                                                    name="select_custom_price"
                                                                    onChange={this.handleChangeCustom(
                                                                      row.id
                                                                    )}
                                                                    placeholder=""
                                                                    style={{
                                                                      width:
                                                                        "100px",
                                                                      textAlign:
                                                                        "center",
                                                                    }}
                                                                    defaultValue={
                                                                      row.data
                                                                        .price
                                                                    }
                                                                    readOnly
                                                                    required
                                                                  />
                                                                </div>
                                                              </td>
                                                              <td>
                                                                {this.formatAsCurrencys(
                                                                  Number(
                                                                    row.data
                                                                      .total
                                                                  )
                                                                )}
                                                              </td>
                                                              <td>
                                                                {row.data
                                                                  .name ===
                                                                  "" ? (
                                                                  <span
                                                                    className="badge badge-outline-primary mr-1"
                                                                    onClick={() =>
                                                                      this.addNewCustomService(
                                                                        row.id
                                                                      )
                                                                    }
                                                                    style={{
                                                                      cursor:
                                                                        "pointer",
                                                                      paddingTop:
                                                                        "3px",
                                                                      paddingBottom:
                                                                        "3px",
                                                                      paddingLeft:
                                                                        "7px",
                                                                      fontSize:
                                                                        "18px",
                                                                    }}
                                                                  >
                                                                    <em className="icon ni ni-save"></em>
                                                                  </span>
                                                                ) : null}
                                                                {/*<span
                                                                  className="badge badge-outline-danger"
                                                                  onClick={() =>
                                                                    this.removeRow(
                                                                      row.id
                                                                    )
                                                                  }
                                                                  style={{
                                                                    cursor:
                                                                      "pointer",
                                                                    paddingTop:
                                                                      "3px",
                                                                    paddingBottom:
                                                                      "3px",
                                                                    paddingLeft:
                                                                      "7px",
                                                                    fontSize:
                                                                      "18px",
                                                                  }}
                                                                >
                                                                  <em className="icon ni ni-trash"></em>
                                                                </span>*/}
                                                              </td>
                                                            </>
                                                          ) : null}
                                                        </tr>
                                                      )}
                                                    </Draggable>
                                                  )
                                                )}
                                              </tbody>
                                              <tfoot>
                                                <tr>
                                                  <td colSpan="5"></td>
                                                  <td colSpan="2">Subtotal</td>
                                                  <td>
                                                    {this.formatAsCurrencys(
                                                      this.state
                                                        .service_grand_sub_total
                                                    )}
                                                  </td>
                                                </tr>
                                                {this.hasValidOrderSummaryData() ? (
                                                  this.state.order_summary_items.map(
                                                    (item, index) => {
                                                      const amount = parseFloat(
                                                        item.applied_amount ||
                                                          item.value ||
                                                          0,
                                                      );
                                                      // Display amount without
                                                      // +/- sign; grand total is
                                                      // computed separately.
                                                      const signedAmount = Math.abs(amount);

                                                      return (
                                                        <tr
                                                          key={`order-summary-${index}`}
                                                        >
                                                          <td colSpan="5"></td>
                                                          <td colSpan="2">
                                                            {item.section_title ||
                                                              item.module_type ||
                                                              "Summary Item"}
                                                            {item.description && (
                                                              <Tooltip title={item.description} placement="top">
                                                                <em className="icon ni ni-info" style={{ marginLeft: "6px", cursor: "pointer", color: "#8094ae", fontSize: "14px" }}></em>
                                                              </Tooltip>
                                                            )}
                                                          </td>
                                                          <td>
                                                            {this.formatAsCurrencys(
                                                              signedAmount,
                                                            )}
                                                          </td>
                                                        </tr>
                                                      );
                                                    },
                                                  )
                                                ) : (
                                                  <>
                                                    {this.state
                                                      .discount_value_total &&
                                                      this.state
                                                        .discount_value_total > 0 ? (
                                                      <tr>
                                                        <td colSpan="5"></td>
                                                        <td colSpan="2">
                                                          {this.state
                                                            .discount_value_total &&
                                                          this.state
                                                            .discount_value_total >
                                                          0 &&
                                                          this.state
                                                            .discount_value_total !==
                                                          "0.00"
                                                            ? "Est. Discount"
                                                            : "Add discount"}
                                                        </td>
                                                        <td>
                                                          {this.formatAsCurrencys(
                                                            parseFloat(
                                                              this.state
                                                                .discount_value_total
                                                            )
                                                          )}
                                                        </td>
                                                      </tr>
                                                    ) : null}
                                                    {this.state
                                                      .shipping_value_total &&
                                                      this.state
                                                        .shipping_value_total > 0 ? (
                                                      <tr>
                                                        <td colSpan="5"></td>
                                                        <td colSpan="2">
                                                          {this.state
                                                            .shipping_value_total &&
                                                          this.state
                                                            .shipping_value_total >
                                                          0 &&
                                                          this.state
                                                            .shipping_value_total !==
                                                          "0.00"
                                                            ? "Est. shipping"
                                                            : "Add shipping or delivery"}
                                                        </td>
                                                        <td>
                                                          {this.formatAsCurrencys(
                                                            parseFloat(
                                                              this.state
                                                                .shipping_value_total
                                                            )
                                                          )}
                                                        </td>
                                                      </tr>
                                                    ) : null}
                                                    {this.state.tax_value_total &&
                                                      this.state.tax_value_total >
                                                      0 ? (
                                                      <tr>
                                                        <td colSpan="5"></td>
                                                        <td colSpan="2">
                                                          {this.state
                                                            .tax_value_total &&
                                                          this.state
                                                            .tax_value_total > 0 &&
                                                          this.state
                                                            .tax_value_total !==
                                                          "0.00"
                                                            ? "Est. tax"
                                                            : "Estimated tax"}
                                                        </td>
                                                        <td>
                                                          {this.formatAsCurrencys(
                                                            parseFloat(
                                                              this.state
                                                                .tax_value_total
                                                            )
                                                          )}
                                                        </td>
                                                      </tr>
                                                    ) : null}
                                                  </>
                                                )}
                                                <tr>
                                                  <td colSpan="5"></td>
                                                  <td colSpan="2">
                                                    Grand Total
                                                  </td>
                                                  <td>
                                                    {this.formatAsCurrencys(
                                                      this.state
                                                        .service_grand_total
                                                    )}
                                                  </td>
                                                </tr>
                                              </tfoot>
                                            </table>
                                          )}
                                        </Droppable>
                                      </DragDropContext>

                                      <div className="nk-notes ff-italic fs-12px text-soft">
                                        {" "}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="tab-pane" id="tabItem6"></div>
                        <div className="tab-pane" id="tabItem7">
                          <div className="row g-gs">
                            <div className="col-xxl-12">
                              <div className="form-group mt-1">
                                <MutextField
                                  required
                                  id="quote_title"
                                  name="quote_title"
                                  type="text"
                                  label="Quotation Title"
                                  value={this.state.quote_title}
                                  onChange={this.handleChange}
                                  variant="outlined"
                                  fullWidth
                                />
                              </div>
                            </div>
                            <div className="col-xxl-12">
                              <h6>Notes:</h6>
                              <div className="form-group mt-1">
                                {this.state.isEditorReady ? (
                                  <>
                                    <CKEditor
                                      onReady={(editor) => {
                                        const editableElement =
                                          editor.ui.getEditableElement();
                                        if (
                                          editableElement &&
                                          editableElement.parentElement
                                        ) {
                                          editableElement.parentElement.insertBefore(
                                            editor.ui.view.toolbar.element,
                                            editableElement
                                          );
                                        }

                                        this.editor = editor;
                                      }}
                                      onError={(
                                        error,
                                        { willEditorRestart }
                                      ) => {
                                        if (willEditorRestart) {
                                          if (
                                            this.editor &&
                                            this.editor.ui &&
                                            this.editor.ui.view &&
                                            this.editor.ui.view.toolbar
                                          ) {
                                            this.editor.ui.view.toolbar.element.remove();
                                          }
                                        }
                                      }}
                                      onChange={(event, editor) =>
                                        this.handleEditorChange(event, editor)
                                      }
                                      editor={DecoupledEditor}
                                      data={this.state.quote_notes}
                                      config={{
                                        cloudServices: {
                                          tokenUrl: fetchToken,
                                          uploadUrl:
                                            API_URL +
                                            "agents/editor_image_upload",
                                        },
                                        toolbar: {
                                          items: [
                                            "undo",
                                            "redo",
                                            "htmlSupport",
                                            "|",
                                            "bold",
                                            "italic",
                                            "underline",
                                            "strikethrough",
                                            "|",
                                            "fontFamily",
                                            "fontSize",
                                            "fontColor",
                                            "fontBackgroundColor",
                                            "|",
                                            "alignment",
                                            "indent",
                                            "outdent",
                                            "|",
                                            "numberedList",
                                            "bulletedList",
                                            "|",
                                            "link",
                                            "imageUpload",
                                            "insertTable",
                                            "|",
                                            "codeBlock",
                                            "blockQuote",
                                            "|",
                                            "removeFormat",
                                            "htmlEmbed",
                                            "fullscreen",
                                          ],
                                        },
                                        language: "en",
                                      }}
                                    />
                                  </>
                                ) : null}
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="tab-pane p-4" id="tabItem8">
                          <div className="row g-gs">
                            <div className="col-xxl-12">
                              <h5>Requirements</h5>
                              <div
                                dangerouslySetInnerHTML={{
                                  __html: this.state.rfq_requirements,
                                }}
                              />
                            </div>
                            {this.state.rfq_attachment &&
                              this.state.rfq_attachment !== "" ? (
                              <div className="col-xxl-12">
                                <h5>Attachment</h5>
                                <table className="table table-striped">
                                  <tbody>
                                    <tr>
                                      <td>Download Attachment</td>
                                      <td>
                                        <a
                                          onClick={() =>
                                            this.downloadPdfRfq(
                                              this.state.rfq_attachment
                                            )
                                          }
                                          style={{ cursor: "pointer" }}
                                          title="Download Attachment"
                                        >
                                          <span className="badge badge-outline-secondary">
                                            {" "}
                                            <em className="icon ni ni-download"></em>{" "}
                                            Download Attachment
                                          </span>
                                        </a>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            ) : null}
                            {this.state.rows_rfq_services &&
                              this.state.rows_rfq_services.length > 0 ? (
                              <div className="col-xxl-12">
                                <h5>RFQ Products & Services</h5>

                                <table className="table table-striped">
                                  <thead>
                                    <tr>
                                      <th className="w-150px">ITEM ID</th>
                                      <th className="w-60">Product name</th>
                                      <th>Quantity</th>
                                      <th>Unit</th>
                                      <th>Add</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {this.state.rows_rfq_services.map(
                                      (row, index) => (
                                        <tr key={index}>
                                          <td>{row.data.id}</td>
                                          <td>{row.data.name}</td>
                                          <td>{row.data.quantity}</td>
                                          <td>{row.data.unit}</td>
                                          <td></td>
                                        </tr>
                                      )
                                    )}
                                  </tbody>
                                </table>
                              </div>
                            ) : null}
                            {this.state.rows_rfq_questions &&
                              this.state.rows_rfq_questions.length > 0 ? (
                              <div className="col-xxl-12">
                                <h5>Questions</h5>

                                <table className="table table-striped">
                                  <thead>
                                    <tr>
                                      <th className="w-150px">Question</th>
                                      <th className="w-60">Answer</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {this.state.rows_rfq_questions.map(
                                      (rfq, index) => (
                                        <tr key={index}>
                                          <td>{rfq.question}</td>
                                          <td>{rfq.answer}</td>
                                        </tr>
                                      )
                                    )}
                                  </tbody>
                                </table>
                              </div>
                            ) : null}
                          </div>
                        </div>
                      </div>
                      <ul className="nk-stepper-pagination pt-4 gx-4 gy-2 stepper-pagination d-flex justify-content-end">
                        <li className="step-next">
                          <button
                            type="button"
                            className="btn btn-wider btn-light"
                            disabled={this.state.disabled}
                            onClick={() =>
                              this.addMenuHistory(
                                "/" +
                                auth.getResellerRegToken() +
                                "/client/Quotations"
                              )
                            }
                          >
                            <em className="icon ni ni-arrow-left"></em>
                            <span>Back</span>
                          </button>
                        </li>
                        {this.state.quote_status !== "" &&
                          this.state.quote_status !== "completed" &&
                          this.state.quote_status !== "cancelled" ? (
                          <li className="step-next">
                            {this.state.send_client_button === true ? (
                              <button
                                className="btn btn-primary"
                                type="button"
                                disabled
                              >
                                <span
                                  className="spinner-grow spinner-grow-sm"
                                  role="status"
                                  aria-hidden="true"
                                ></span>
                                <span> Sending to Customer... </span>
                              </button>
                            ) : (
                              <button
                                type="button"
                                className="btn btn-wider btn-success"
                                disabled={this.state.disabled}
                                onClick={() => this.openSignAndPay()}
                              >
                                <em className="icon ni ni-check-round-cut"></em>
                                <span>Sign & Pay</span>
                              </button>
                            )}
                          </li>
                        ) : null}
                      </ul>
                    </div>

                    {this.state.rows_optional &&
                      this.state.rows_optional.length > 0 ? (
                      <div className="col-lg-12 mb-5 border-top pt-5">
                        <div className="col-xxl-12 inner_content">
                          <h5>Optional Items</h5>
                          <div className="invoice">
                            <div
                              className="invoice-wrap"
                              style={{ padding: "1rem" }}
                            >
                              <div className="invoice-bills">
                                <div className=" genericTable">
                                  <DragDropContext
                                    onDragEnd={this.handleDragEndOptional}
                                  >
                                    <Droppable droppableId="droppable-2">
                                      {(provided) => (
                                        <table
                                          ref={provided.innerRef}
                                          {...provided.droppableProps}
                                          className="table table-striped"
                                        >
                                          <thead>
                                            <tr>
                                              <th
                                                className="w-5 text-left"
                                                style={{
                                                  paddingLeft: "1.25rem",
                                                }}
                                              >
                                                <em className="icon ni ni-move"></em>
                                              </th>
                                              <th className="w-10">ITEM ID</th>
                                              <th className="w-10">SKU</th>
                                              <th className="w-20">
                                                PRODUCT NAME
                                              </th>
                                              <th>QTY</th>
                                              <th>UNIT</th>
                                              <th>PRICE($)</th>
                                              <th>TOTAL($)</th>
                                              <th>&nbsp;</th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            {this.state.rows_optional.map(
                                              (row, index) => (
                                                <Draggable
                                                  key={row.id}
                                                  draggableId={`${row.id}-2`}
                                                  index={index}
                                                >
                                                  {(provided) => (
                                                    <tr
                                                      ref={provided.innerRef}
                                                      {...provided.draggableProps}
                                                      {...provided.dragHandleProps}
                                                    >
                                                      {row.data.type &&
                                                        row.data.type ===
                                                        "service" ? (
                                                        <>
                                                          <td>
                                                            <em className="icon ni ni-move"></em>
                                                          </td>
                                                          <td>
                                                            {row.data.id &&
                                                              row.data.id !== ""
                                                              ? row.data.id
                                                              : "---"}
                                                          </td>
                                                          <td>
                                                            {row.data.sku &&
                                                              row.data.sku !== ""
                                                              ? row.data.sku
                                                              : "---"}
                                                          </td>
                                                          <td>
                                                            {row.data.name !==
                                                              "" ? (
                                                              row.data.name &&
                                                                row.data.name !==
                                                                "" ? (
                                                                row.data.name
                                                              ) : (
                                                                "---"
                                                              )
                                                            ) : (
                                                              <Select
                                                                options={
                                                                  this.state
                                                                    .all_select_services
                                                                }
                                                                name="select_a_service_optional"
                                                                placeholder="Select product / service"
                                                                value={
                                                                  this.state
                                                                    .select_a_service_optional
                                                                }
                                                                autoComplete="off"
                                                                emptyMessage="Product not found"
                                                                onChange={
                                                                  this
                                                                    .handleChangeSearchOptional
                                                                }
                                                                isClearable
                                                                isSearchable
                                                                components={
                                                                  animatedComponents
                                                                }
                                                              />
                                                            )}
                                                          </td>
                                                          <td>
                                                            <div className="form-control-wrap">
                                                              <input
                                                                type="text"
                                                                className="form-control"
                                                                id="quantity"
                                                                name="quantity"
                                                                onChange={this.handleChangeServicesOptional(
                                                                  row.id
                                                                )}
                                                                placeholder=""
                                                                style={{
                                                                  width: "60px",
                                                                  textAlign:
                                                                    "center",
                                                                }}
                                                                defaultValue={
                                                                  row.data
                                                                    .quantity
                                                                }
                                                                required
                                                                readOnly
                                                              />
                                                            </div>
                                                          </td>
                                                          <td>
                                                            <div className="form-control-wrap">
                                                              <input
                                                                type="text"
                                                                className="form-control"
                                                                id="unit"
                                                                name="unit"
                                                                onChange={this.handleChangeServicesOptional(
                                                                  row.id
                                                                )}
                                                                placeholder=""
                                                                style={{
                                                                  width:
                                                                    "100px",
                                                                  textAlign:
                                                                    "center",
                                                                }}
                                                                defaultValue={
                                                                  row.data.unit
                                                                }
                                                                required
                                                                readOnly
                                                              />
                                                            </div>
                                                          </td>
                                                          <td>
                                                            <div className="form-control-wrap">
                                                              <input
                                                                type="text"
                                                                className="form-control"
                                                                id="price"
                                                                name="price"
                                                                onChange={this.handleChangeServicesOptional(
                                                                  row.id
                                                                )}
                                                                placeholder=""
                                                                style={{
                                                                  width:
                                                                    "100px",
                                                                  textAlign:
                                                                    "center",
                                                                }}
                                                                defaultValue={
                                                                  row.data.price
                                                                }
                                                                required
                                                                readOnly
                                                              />
                                                            </div>
                                                          </td>
                                                          <td>
                                                            {this.formatAsCurrencys(
                                                              Number(
                                                                row.data.total
                                                              )
                                                            )}
                                                          </td>
                                                          <td>
                                                            {row.data.name ===
                                                              "" ? (
                                                              <span
                                                                className="badge badge-outline-primary mr-1"
                                                                onClick={() =>
                                                                  this.addNewServiceOptional(
                                                                    row.id
                                                                  )
                                                                }
                                                                style={{
                                                                  cursor:
                                                                    "pointer",
                                                                  paddingTop:
                                                                    "3px",
                                                                  paddingBottom:
                                                                    "3px",
                                                                  paddingLeft:
                                                                    "7px",
                                                                  fontSize:
                                                                    "18px",
                                                                }}
                                                              >
                                                                <em className="icon ni ni-save"></em>
                                                              </span>
                                                            ) : null}
                                                            {this.state
                                                              .quote_status !==
                                                              "completed" &&
                                                              this.state
                                                                .quote_status !==
                                                              "cancelled" ? (
                                                              <span
                                                                className="badge badge-outline-primary"
                                                                onClick={() =>
                                                                  this.addToCart(
                                                                    row.data.id
                                                                  )
                                                                }
                                                                title="Add item to order lines"
                                                                style={{
                                                                  cursor:
                                                                    "pointer",
                                                                  paddingTop:
                                                                    "3px",
                                                                  paddingBottom:
                                                                    "3px",
                                                                  paddingLeft:
                                                                    "7px",
                                                                  fontSize:
                                                                    "18px",
                                                                }}
                                                              >
                                                                <em className="icon ni ni-cart-fill"></em>
                                                              </span>
                                                            ) : null}
                                                          </td>
                                                        </>
                                                      ) : row.data.type ===
                                                        "section" ? (
                                                        <>
                                                          <td>
                                                            <em className="icon ni ni-move"></em>
                                                          </td>
                                                          <td
                                                            style={{
                                                              fontWeight:
                                                                "bold",
                                                            }}
                                                            colSpan={6}
                                                          >
                                                            {row.data.name &&
                                                              row.data.name !==
                                                              "" ? (
                                                              row.data.name
                                                            ) : (
                                                              <div className="form-control-wrap">
                                                                <input
                                                                  type="text"
                                                                  className="form-control"
                                                                  id="select_name"
                                                                  name="select_name"
                                                                  onChange={this.handleChangeSectionOptional(
                                                                    row.id
                                                                  )}
                                                                  placeholder=""
                                                                  autoComplete="off"
                                                                  defaultValue={
                                                                    row.data
                                                                      .name
                                                                  }
                                                                  required
                                                                />
                                                              </div>
                                                            )}
                                                          </td>
                                                          <td>
                                                            {row.data.name ===
                                                              "" ? (
                                                              <span
                                                                className="badge badge-outline-primary mr-1"
                                                                onClick={() =>
                                                                  this.addNewSectionOptional(
                                                                    row.id
                                                                  )
                                                                }
                                                                style={{
                                                                  cursor:
                                                                    "pointer",
                                                                  paddingTop:
                                                                    "3px",
                                                                  paddingBottom:
                                                                    "3px",
                                                                  paddingLeft:
                                                                    "7px",
                                                                  fontSize:
                                                                    "18px",
                                                                }}
                                                              >
                                                                <em className="icon ni ni-save"></em>
                                                              </span>
                                                            ) : null}
                                                            <span
                                                              className="badge badge-outline-danger"
                                                              onClick={() =>
                                                                this.removeRowOptional(
                                                                  row.id
                                                                )
                                                              }
                                                              style={{
                                                                cursor:
                                                                  "pointer",
                                                                paddingTop:
                                                                  "3px",
                                                                paddingBottom:
                                                                  "3px",
                                                                paddingLeft:
                                                                  "7px",
                                                                fontSize:
                                                                  "18px",
                                                              }}
                                                            >
                                                              <em className="icon ni ni-trash"></em>
                                                            </span>
                                                          </td>
                                                        </>
                                                      ) : null}
                                                    </tr>
                                                  )}
                                                </Draggable>
                                              )
                                            )}
                                          </tbody>
                                        </table>
                                      )}
                                    </Droppable>
                                  </DragDropContext>

                                  <div className="nk-notes ff-italic fs-12px text-soft">
                                    {" "}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : null}
                    {this.state.quote_notes && this.state.quote_notes !== "" ? (
                      <div className="col-lg-12 mb-5 border-top pt-5">
                        <div className="col-xxl-12 inner_content">
                          <h5>Other Info</h5>
                          <div
                            dangerouslySetInnerHTML={{
                              __html: this.state.quote_notes,
                            }}
                          />
                        </div>
                      </div>
                    ) : null}
                    <div
                      className="col-xxl-12 border-top mb-4"
                      id="feedbackContainer"
                    >
                      <div
                        className="simplebar-content-wrapper"
                        style={{ height: "100%" }}
                      >
                        <div
                          className="simplebar-content"
                          style={{ padding: "0px" }}
                        >
                          {this.state.convErrorMessage !== "" ? (
                            <div
                              className="example-alert mt-4"
                              style={{ marginBottom: "15px" }}
                            >
                              <div className="alert alert-pro alert-danger">
                                <div className="alert-text">
                                  <h4>Error</h4>
                                  <p>{this.state.convErrorMessage}</p>
                                </div>
                              </div>
                            </div>
                          ) : null}
                          <div className="nk-msg-head py-4 d-none">
                            <h4 className="title">
                              Unable to select currency when order
                            </h4>
                            <ul className="nk-msg-tags">
                              <li>
                                <span className="label-tag">
                                  <em className="icon ni ni-flag-fill"></em>{" "}
                                  <span>Technical Problem</span>
                                </span>
                              </li>
                            </ul>
                          </div>
                          {this.state.quote_status !== "cancelled" ? (
                            <div className="nk-reply-form mt-5">
                              <div className="nk-reply-form-header">
                                <ul className="nav nav-tabs-s2 nav-tabs nav-tabs-sm">
                                  <li className="nav-item">
                                    <a
                                      className="nav-link active"
                                      data-toggle="tab"
                                      href="#reply-form"
                                    >
                                      Leave Comment
                                    </a>
                                  </li>
                                </ul>
                              </div>
                              <div className="tab-content">
                                <div className="tab-pane active" id="reply-form">
                                  <div className="nk-reply-form-editor">
                                    <div className="nk-reply-form-field">
                                      <textarea
                                        name="quote_comment"
                                        id="quote_comment"
                                        onChange={this.handleChange}
                                        value={this.state.quote_comment}
                                        className="form-control form-control-simple no-resize"
                                        placeholder="Leave a comment here"
                                      ></textarea>
                                    </div>
                                    <div className="nk-reply-form-tools">
                                      <ul className="nk-reply-form-actions g-1">
                                        <li className="mr-2">
                                          {this.state.quote_comment_button ===
                                            true ? (
                                            <button
                                              className="btn btn-primary"
                                              type="button"
                                              disabled
                                            >
                                              <span
                                                className="spinner-border spinner-border-sm"
                                                role="status"
                                                aria-hidden="true"
                                              ></span>
                                              <span className="sr-only">
                                                Loading...
                                              </span>
                                            </button>
                                          ) : (
                                            <button
                                              onClick={() => this.addComment()}
                                              className="btn btn-primary"
                                              type="button"
                                            >
                                              Post
                                            </button>
                                          )}
                                        </li>
                                      </ul>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          ) : null}
                          {this.state.conversations &&
                            this.state.conversations.length > 0 ? (
                            <>
                              {this.state.conversations.map((quote, index) => (
                                <div
                                  className="nk-reply-item"
                                  key={`keys-${index}`}
                                >
                                  <div className="nk-reply-header">
                                    <div className="user-card">
                                      {quote.from_admin !== "" ? (
                                        <div className="user-avatar sm bg-blue">
                                          <span>AD</span>
                                        </div>
                                      ) : quote.from_client !== "" ? (
                                        <div className="user-avatar sm bg-pink">
                                          <span>CL</span>
                                        </div>
                                      ) : null}

                                      <div className="user-name">
                                        {quote.from_admin !== ""
                                          ? quote.from_admin
                                          : quote.from_client !== ""
                                            ? quote.from_client
                                            : null}
                                      </div>
                                    </div>
                                    <div className="date-time">
                                      {this.format_date(quote.dateAdded)}
                                    </div>
                                  </div>
                                  <div className="nk-reply-body">
                                    <div className="nk-reply-entry entry">
                                      <p>Hello,</p>
                                      <p>{quote.conversation}</p>
                                      {quote.from_admin !== "" ? (
                                        <p>
                                          Thank you <br /> {quote.from_admin}
                                        </p>
                                      ) : null}
                                      {quote.from_client !== "" ? (
                                        <p>
                                          Thank you <br /> {quote.from_client}
                                        </p>
                                      ) : null}
                                    </div>
                                    {quote.quote_file !== "" ? (
                                      <div className="attach-files invoicefiles">
                                        <ul className="attach-list">
                                          <li className="attach-item">
                                            <a className="download" href="#">
                                              <em className="icon ni ni-img"></em>
                                              <span>{quote.quote_file}</span>
                                            </a>
                                          </li>
                                        </ul>
                                        <div className="attach-foot">
                                          <span className="attach-info">
                                            1 file attached
                                          </span>
                                          {this.state.download_start ===
                                            true ? (
                                            <div
                                              className="spinner-border spinner-border-sm"
                                              role="status"
                                            >
                                              <span className="sr-only">
                                                Loading...
                                              </span>
                                            </div>
                                          ) : (
                                            <a
                                              className="attach-download link"
                                              onClick={() =>
                                                this.downloadPdf(
                                                  quote.quote_file
                                                )
                                              }
                                              style={{ cursor: "pointer" }}
                                            >
                                              <em className="icon ni ni-download"></em>
                                              <span>Download</span>
                                            </a>
                                          )}
                                        </div>
                                      </div>
                                    ) : null}
                                  </div>
                                </div>
                              ))}
                            </>
                          ) : null}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Table 5th Col End */}
                {/*** Alert Modal ***/}
                <div className="modal fade" tabIndex="-1" id="modalAlertCart">
                  <div className="modal-dialog" role="document">
                    <div className="modal-content">
                      <div className="modal-body modal-body-lg text-center">
                        <div className="nk-modal">
                          <em className="nk-modal-icon icon icon-circle icon-circle-xxl ni ni-cross bg-danger"></em>
                          <h4 className="nk-modal-title">Unable to Process!</h4>
                          <div className="nk-modal-text">
                            <p className="lead">
                              {this.state.service_already_eists_message}
                            </p>
                          </div>
                          <div className="nk-modal-action mt-5">
                            <a
                              href="#"
                              className="btn btn-lg btn-mw btn-light"
                              data-dismiss="modal"
                            >
                              Close
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="modal fade"
                  tabIndex="-1"
                  id="modalAlertCartSuccess"
                >
                  <div className="modal-dialog" role="document">
                    <div className="modal-content">
                      <a href="#" className="close" data-dismiss="modal">
                        <em className="icon ni ni-cross"></em>
                      </a>
                      <div className="modal-body modal-body-lg text-center">
                        <div className="nk-modal">
                          <em className="nk-modal-icon icon icon-circle icon-circle-xxl ni ni-check bg-success"></em>
                          <h4 className="nk-modal-title">Congratulations!</h4>
                          <div className="nk-modal-text">
                            <div className="caption-text">
                              {this.state.service_success_message}
                            </div>
                          </div>
                          <div className="nk-modal-action">
                            <a
                              href="#"
                              className="btn btn-lg btn-mw btn-primary"
                              data-dismiss="modal"
                            >
                              OK
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/*** Alert Modal ***/}
                <div className="modal fade " tabIndex="-1" id="modalSignAndPay">
                  <div
                    className="modal-dialog modal-xl modal-dialog-top"
                    role="document"
                  >
                    <div className="modal-content">
                      <a
                        href="#"
                        className="close"
                        data-dismiss="modal"
                        aria-label="Close"
                      >
                        <em className="icon ni ni-cross"></em>
                      </a>
                      <div className="modal-header">
                        <h5 className="modal-title">Validate Order</h5>
                      </div>
                      <div className="modal-body">
                        {this.state.errorMessagePay !== "" ? (
                          <div
                            className="example-alert"
                            style={{ marginBottom: "15px" }}
                          >
                            <div className="alert alert-pro alert-danger">
                              <div className="alert-text">
                                <h4>{this.state.errorMessagePayTitle}</h4>
                                <p>{this.state.errorMessagePay}</p>
                              </div>
                            </div>
                          </div>
                        ) : null}
                        {this.state.successMessagePay !== "" ? (
                          <div
                            className="example-alert"
                            style={{ marginBottom: "15px" }}
                          >
                            <div className="alert alert-pro alert-success">
                              <div className="alert-text">
                                <h4>Success</h4>
                                <p>{this.state.successMessagePay}</p>
                              </div>
                            </div>
                          </div>
                        ) : null}
                        <p>
                          By signing this proposal, I agree to the following
                          terms,
                        </p>
                        <ul className="list">
                          <li>
                            Accepted on behlf of:{" "}
                            <b>{this.state.client_company}</b>
                          </li>
                          <li>
                            For an amount of:{" "}
                            <b>
                              {this.formatAsCurrencys(
                                this.state.service_grand_total
                              )}
                            </b>
                          </li>
                          {this.state.unsignedArray &&
                            this.state.unsignedArray.length > 0 ? (
                            <>
                              <p style={{ color: "#e85347" }}>
                                Agreements not signed for the following
                                quotation services:
                              </p>
                              {this.state.unsignedArray.map((unsign, index) => (
                                <li key={index} style={{ color: "#e85347" }}>
                                  <b>Service:</b> {unsign.service_name}
                                  <br />
                                  <b>Agreement:</b> {unsign.agreement_title}{" "}
                                  <a
                                    href={`${APP_URL}client/agreements/unsignedAgreements`}
                                    target="_blank"
                                  >
                                    <span
                                      className="badge badge-outline-primary"
                                      style={{
                                        color: "#6576ff",
                                        borderColor: "#6576ff",
                                      }}
                                    >
                                      Sign
                                    </span>
                                  </a>
                                </li>
                              ))}
                              <b>NOTE:</b> Please refresh the page after signing
                              the agreements.
                            </>
                          ) : null}
                        </ul>
                        {this.state.agreementContent !== "" ? (
                          <div
                            style={{
                              maxHeight: "300px",
                              overflowY: "auto",
                              border: "1px solid #ccc",
                              padding: "10px",
                            }}
                          >
                            {" "}
                            {/* <h2>{this.state.agreementTitle}</h2> */}{" "}
                            <div>
                              {" "}
                              <div
                                dangerouslySetInnerHTML={{
                                  __html: this.state.agreementContent,
                                }}
                              />{" "}
                            </div>{" "}
                          </div>
                        ) : null}

                        {this.state.quotation_signature &&
                          this.state.quotation_signature !== "" ? (
                          <div className="nk-block nk-block-sm mt-4">
                            <div className="nk-block-head nk-block-head-sm">
                              <div className="nk-block-between">
                                <div className="nk-block-head-content">
                                  <h6 className="nk-block-title">Signature</h6>
                                </div>
                              </div>
                            </div>

                            <div className="tranx-list tranx-list-stretch card">
                              <div className="tranx-item">
                                <div className="tranx-col">
                                  <div className="tranx-info">
                                    <div className="tranx-badge">
                                      <img
                                        src={this.state.quotation_signature}
                                        style={{ height: "40px" }}
                                        alt=""
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        ) : null}

                        {this.state.final_form_step === "payment" ? (
                          <div className="col-md-12">
                            <h5 className="mb-4 mt-3">Choose Payment Method</h5>
                            <ul
                              className="nk-kycfm-control-list g-3"
                              style={{ width: "100%" }}
                            >
                              <li className="nk-kycfm-control-item">
                                <input
                                  checked={this.state.payment_method === "bank"}
                                  onChange={this.handleChangeCheckbox}
                                  className="nk-kycfm-control"
                                  type="radio"
                                  name="payment_method"
                                  id="metered"
                                  data-title="Account Details"
                                  value="bank"
                                />
                                <label
                                  className="nk-kycfm-label"
                                  htmlFor="metered"
                                >
                                  <span className="nk-kycfm-label-icon">
                                    <div className="label-icon">
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 71.9904 75.9285"
                                      >
                                        <path
                                          d="M27.14,23.73A15.55,15.55,0,1,0,42.57,39.4v-.12A15.5,15.5,0,0,0,27.14,23.73Zm11.42,9.72H33a25.55,25.55,0,0,0-2.21-6.53A12.89,12.89,0,0,1,38.56,33.45ZM31,39.28a26.9929,26.9929,0,0,1-.2,3.24H23.49a26.0021,26.0021,0,0,1,0-6.48H30.8A29.3354,29.3354,0,0,1,31,39.28ZM26.77,26.36h.75a21.7394,21.7394,0,0,1,2.85,7.09H23.91A21.7583,21.7583,0,0,1,26.77,26.36Zm-3.28.56a25.1381,25.1381,0,0,0-2.2,6.53H15.72a12.88,12.88,0,0,1,7.78-6.53ZM14.28,39.28A13.2013,13.2013,0,0,1,14.74,36H20.9a29.25,29.25,0,0,0,0,6.48H14.74A13.1271,13.1271,0,0,1,14.28,39.28Zm1.44,5.83h5.57a25.9082,25.9082,0,0,0,2.2,6.53A12.89,12.89,0,0,1,15.72,45.11ZM27.51,52.2h-.74a21.7372,21.7372,0,0,1-2.85-7.09h6.44A21.52,21.52,0,0,1,27.51,52.2Zm3.28-.56A25.1413,25.1413,0,0,0,33,45.11h5.57a12.84,12.84,0,0,1-7.77,6.53Zm2.59-9.12a28.4606,28.4606,0,0,0,0-6.48h6.15a11.7,11.7,0,0,1,0,6.48ZM14.29,62.6H40v2.6H14.28V62.61ZM56.57,49l1.33-5,2.48.67-1.33,5Zm-6,22.52L55.24,54l2.48.67L53.06,72.14Zm21.6-61.24-29.8-8a5.13,5.13,0,0,0-6.29,3.61h0L33.39,16H6.57A2.58,2.58,0,0,0,4,18.55V70.38A2.57,2.57,0,0,0,6.52,73L6.57,73h29.7l17.95,4.85a5.12,5.12,0,0,0,6.28-3.6v-.06L75.8,16.61a5.18,5.18,0,0,0-3.6066-6.3763L72.18,10.23ZM6.57,70.38V18.55H45.14a2.57,2.57,0,0,1,2.57,2.57V67.79a2.57,2.57,0,0,1-2.55,2.59H6.57ZM73.34,15.91,58,73.48a2.59,2.59,0,0,1-2.48,1.93,2.5192,2.5192,0,0,1-.67-.09l-9-2.42a5.15,5.15,0,0,0,4.37-5.11V47.24l1.32.36,1.33-5-2.49-.67-.16.62V21.94l2.62.71,3.05,10,2.13.57L57.88,24l3.76,1,1.65,3,1.42.39-.25-4.09,2.24-3.42-1.41-.39L62.4,22.15l-3.76-1,4.76-7.92-2.13-.57-7.6,7.14-4-1.08A5.1,5.1,0,0,0,45.14,16H36.05l2.51-9.45a2.57,2.57,0,0,1,3.12-1.84h0l29.81,8.05a2.56,2.56,0,0,1,1.56,1.21A2.65,2.65,0,0,1,73.34,15.91ZM56.57,39.59l.66-2.5,2.44.65L59,40.24Zm4.88,1.31.66-2.51,2.44.66-.65,2.5Zm-9.76-2.61.66-2.51,2.45.66-.66,2.5Z"
                                          transform="translate(-3.9995 -2.101)"
                                          fill="#6476ff"
                                        />
                                      </svg>
                                    </div>
                                  </span>
                                  <span className="nk-kycfm-label-text">
                                    Account Details
                                  </span>
                                </label>
                              </li>

                              {/*<li className="nk-kycfm-control-item">
                                <input
                                  className="nk-kycfm-control"
                                  type="radio"
                                  name="payment_method"
                                  id="unmetered"
                                  data-title="Wire Transfer"
                                  onChange={this.handleChangeCheckbox}
                                  checked={this.state.payment_method === "wire"}
                                  value="wire"
                                />
                                <label
                                  className="nk-kycfm-label"
                                  htmlFor="unmetered"
                                >
                                  <span className="nk-kycfm-label-icon">
                                    <div className="label-icon">
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 76 63.0105"
                                      >
                                        <path
                                          d="M76,18.79,56.53,9.56a6.19,6.19,0,0,0-5.19,0l-19.5,9.23a3.35,3.35,0,0,0-1.9,2.55H8.33A6.26,6.26,0,0,0,2,27.51v38.3A6.27,6.27,0,0,0,8.33,72H71.67A6.27,6.27,0,0,0,78,65.81v-44A3.37,3.37,0,0,0,76,18.79Zm-.56,47a3.77,3.77,0,0,1-3.8,3.71H8.33a3.77,3.77,0,0,1-3.8-3.71V27.51a3.75,3.75,0,0,1,3.7993-3.7H29.87v9.34A34.49,34.49,0,0,0,44,60.41l7.51,5.8a4.11,4.11,0,0,0,4.94,0l7.51-5.8A36.5307,36.5307,0,0,0,75.47,45.62V65.81Zm0-32.66a32.09,32.09,0,0,1-13.1,25.34l-7.51,5.8a1.5,1.5,0,0,1-1.8,0l-7.51-5.8A32.05,32.05,0,0,1,32.4,33.15V21.83A.91.91,0,0,1,33,21l19.5-9.23a3.51,3.51,0,0,1,3,0L74.92,21a.91.91,0,0,1,.55.82V33.15ZM53.87,21.43a12.47,12.47,0,0,0-12.6,12.31,12.62,12.62,0,0,0,25.23,0,12.46,12.46,0,0,0-12.6178-12.3l-.0122,0Zm0,22.14A9.83,9.83,0,1,1,64,33.78a10,10,0,0,1-10.1,9.79Zm3.31-13.22-5.32,5.19-1.18-1.15a1.29,1.29,0,0,0-1.79,0,1.2,1.2,0,0,0-.013,1.697l.013.013h0l2.08,2a1.27,1.27,0,0,0,1.79,0L59,32.09a1.22,1.22,0,0,0,0-1.72h0a1.29,1.29,0,0,0-1.8,0ZM29.87,57.16h-20a1.24,1.24,0,1,0,0,2.47h20a1.24,1.24,0,0,0,0-2.47ZM19.73,62.1H9.89a1.24,1.24,0,0,0,0,2.48h9.84a1.24,1.24,0,0,0,0-2.48Zm8.66-14.28h0L24,45.71a.36.36,0,0,1-.22-.34V44.16a1.878,1.878,0,0,1,.18-.24,10.9991,10.9991,0,0,0,1.35-2.48,2.53,2.53,0,0,0,1.23-2.16V37.51a2.61,2.61,0,0,0-.46-1.43V34a4.69,4.69,0,0,0-1.15-3.43,6.68,6.68,0,0,0-5.19-1.85,6.67,6.67,0,0,0-5.18,1.85A4.61,4.61,0,0,0,13.4,34v2a2.46,2.46,0,0,0-.46,1.43v1.78a2.49,2.49,0,0,0,.78,1.81,10.148,10.148,0,0,0,1.52,3v1.2a.36.36,0,0,1-.21.33l-4.1,2.15A4.79,4.79,0,0,0,8.33,52v1.43a1.26,1.26,0,0,0,.37.88,1.33,1.33,0,0,0,.9.36H29.87a1.31,1.31,0,0,0,.9-.36,1.26,1.26,0,0,0,.37-.88V52.11A4.76,4.76,0,0,0,28.39,47.82Zm.21,4.4H10.87V52a2.27,2.27,0,0,1,1.25-2l4.12-2.16a2.85,2.85,0,0,0,1.54-2.5V43.72a1.3,1.3,0,0,0-.3-.8,7.39,7.39,0,0,1-1.4-2.8,1.53,1.53,0,0,0-.6-.83V37.46a1.22,1.22,0,0,0,.43-.92v-2.7a2.17,2.17,0,0,1,.53-1.58,4.38,4.38,0,0,1,3.28-1,4.43,4.43,0,0,1,3.26,1,2.22,2.22,0,0,1,.55,1.6.8552.8552,0,0,0,0,.16v2.56a1.36,1.36,0,0,0,.46,1l-.08,1.86a1.23,1.23,0,0,0-.84.8,8.5819,8.5819,0,0,1-1.19,2.31c-.1.14-.22.28-.33.41a1.22,1.22,0,0,0-.33.82v1.66A2.86,2.86,0,0,0,22.86,48l4.41,2a2.28,2.28,0,0,1,1.33,2.07v.15Z"
                                          transform="translate(-2 -8.9898)"
                                          fill="#6476ff"
                                        />
                                      </svg>
                                    </div>
                                  </span>
                                  <span className="nk-kycfm-label-text">
                                    Wire Transfer
                                  </span>
                                </label>
                        </li>*/}
                            </ul>
                            <div className="example-alert mt-4 mb-4">
                              <div className="alert alert-light ">
                                <div className="row d-flex justify-content-end mb-4">
                                  <CopyToClipboard
                                    text={
                                      this.state.payment_method === "wire"
                                        ? this.state.wire_transfer_details_plain
                                        : this.state.bank_account_details_plain
                                    }
                                    onCopy={() =>
                                      this.setState({ copied: true })
                                    }
                                  >
                                    <button className="btn btn-success">
                                      <em className="icon ni ni-copy"></em> Copy
                                      to clipboard{" "}
                                      {this.state.copied ? (
                                        <span style={{ color: "white" }}>
                                          <em className="icon ni ni-done"></em>
                                        </span>
                                      ) : null}
                                    </button>
                                  </CopyToClipboard>
                                </div>
                                {this.state.payment_method === "wire" ? (
                                  <div
                                    dangerouslySetInnerHTML={{
                                      __html: this.state.wire_transfer_details,
                                    }}
                                  />
                                ) : this.state.payment_method === "bank" ? (
                                  <div
                                    dangerouslySetInnerHTML={{
                                      __html: this.state.bank_account_details,
                                    }}
                                  />
                                ) : null}
                              </div>
                            </div>
                            <div className="row d-flex justify-content-end border-top margin-top-popup">
                              <div className="" style={{ float: "right" }}>
                                <button
                                  className="btn btn-light btn-lg"
                                  style={{
                                    margin: "13px 12px 12px 10px",
                                  }}
                                  onClick={() => this.moveToSignature()}
                                  id=""
                                >
                                  <em className="icon ni ni-back-ios"></em>{" "}
                                  <span>Back</span>{" "}
                                </button>
                                {this.state.finalPayButton === true ? (
                                  <button
                                    className="btn btn-primary btn-lg"
                                    type="button"
                                    id="loading_btn"
                                    disabled
                                  >
                                    <span
                                      className="spinner-grow spinner-grow-sm"
                                      role="status"
                                      aria-hidden="true"
                                    ></span>
                                    <span> Processing... </span>
                                  </button>
                                ) : this.state.finalPayButton === false ? (
                                  <button
                                    className="btn btn-success btn-lg"
                                    style={{
                                      color: THEME_TEXT_COLOR,
                                      margin: "13px 12px 12px 10px",
                                    }}
                                    onClick={() => this.saveSalesOrder()}
                                    id=""
                                  >
                                    <em className="icon ni ni-cc-alt2"></em>{" "}
                                    <span>Accept & Pay</span>{" "}
                                  </button>
                                ) : null}
                              </div>
                            </div>
                          </div>
                        ) : this.state.final_form_step === "signature" ? (
                          <>
                            <ul className="nav nav-tabs">
                              <li className="nav-item">
                                <a
                                  className="nav-link active"
                                  onClick={() =>
                                    this.updateSignatureType("draw")
                                  }
                                  data-toggle="tab"
                                  href="#drawSignature"
                                >
                                  <em className="icon ni ni-edit-alt"></em>
                                  <span>Draw</span>
                                </a>
                              </li>
                              <li className="nav-item">
                                <a
                                  className="nav-link"
                                  onClick={() =>
                                    this.updateSignatureType("choose")
                                  }
                                  data-toggle="tab"
                                  href="#chooseSignature"
                                >
                                  <em className="icon ni ni-template"></em>
                                  <span>Choose</span>
                                </a>
                              </li>
                            </ul>
                            <div className="tab-content">
                              <div className="tab-pane active" id="drawSignature">
                                <div
                                  className="form-group col-md-12 mb-4"
                                  id="signature_div_inner"
                                >
                                  <div className="row g-gs">
                                    <div className="col-md-12 ">
                                      <div className="example-alert mb-4">
                                        <div className="alert alert-light">
                                          Please Save the signature to proceed.
                                        </div>
                                      </div>
                                      <h6>Signature</h6>
                                      <div
                                        className="form-group"
                                        style={{ height: "150px" }}
                                        id="signature-pad"
                                      >
                                        {this.state.show_signature === true ? (
                                          <SignatureCanvas
                                            clearOnResize={false}
                                            canvasProps={{
                                              className: "sigCanvas",
                                            }}
                                            velocityFilterWeight={0.7}
                                            throttle={40}
                                            ref={(ref) => {
                                              this.signaturePad = ref;
                                            }}
                                          />
                                        ) : (
                                          HeadBodyGrid()
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="row d-flex justify-content-end border-top margin-top-popup">
                                  <div className="" style={{ float: "right" }}>
                                    <button
                                      className="btn btn-lg btn-warning"
                                      style={{
                                        margin: "13px 12px 12px 10px",
                                      }}
                                      onClick={() => this.clear()}
                                    >
                                      Clear
                                    </button>
                                    {this.state.quotation_signature &&
                                      this.state.quotation_signature !== "" ? (
                                      <button
                                        className="btn btn-light btn-lg"
                                        style={{
                                          margin: "13px 12px 12px 10px",
                                        }}
                                        onClick={() => this.moveToPayment()}
                                      >
                                        <span>Skip</span>{" "}
                                        <em className="icon ni ni-arrow-right-round"></em>{" "}
                                      </button>
                                    ) : null}
                                    {this.state.finalPayButton === true ? (
                                      <button
                                        className="btn btn-primary btn-lg"
                                        type="button"
                                        id="loading_btn"
                                        disabled
                                      >
                                        <span
                                          className="spinner-grow spinner-grow-sm"
                                          role="status"
                                          aria-hidden="true"
                                        ></span>
                                        <span> Processing... </span>
                                      </button>
                                    ) : this.state.finalPayButton === false ? (
                                      <>
                                        {this.state.unsignedArray &&
                                          this.state.unsignedArray.length ===
                                          0 ? (
                                          <button
                                            className="btn btn-primary btn-lg"
                                            style={{
                                              color: THEME_TEXT_COLOR,
                                              margin: "13px 12px 12px 10px",
                                            }}
                                            onClick={() => this.saveSignature()}
                                            id=""
                                          >
                                            <em className="icon ni ni-check-round-cut"></em>{" "}
                                            <span>Accept & Sign</span>{" "}
                                          </button>
                                        ) : null}
                                      </>
                                    ) : null}
                                  </div>
                                </div>
                              </div>
                              <div className="tab-pane" id="chooseSignature">
                                <div className="col-md-12">
                                  <div className="example-alert">
                                    <div className="alert alert-light">
                                      Pick a style for your signature
                                      (Authorized Person Name).
                                    </div>
                                  </div>
                                  <div className="form-group mt-4">
                                    <div className="form-group">
                                      <MutextField
                                        required
                                        id="signatureText"
                                        name="signatureText"
                                        type="text"
                                        label="Authorized Person Name"
                                        inputProps={{ maxLength: 30 }}
                                        onInput={(e) => {
                                          e.target.value =
                                            e.target.value.replace(
                                              /[^a-zA-Z0-9 ]/gi,
                                              ""
                                            );
                                        }}
                                        defaultValue={this.state.signatureText}
                                        onChange={this.handleChange}
                                        helperText=""
                                        variant="outlined"
                                        fullWidth
                                      />
                                    </div>
                                    <h6 className="title">Choose Style</h6>

                                    <ul className="cc-pay-method">
                                      <li className="cc-pay-dd dropdown">
                                        <a
                                          href="#"
                                          className="btn btn-white btn-outline-light dropdown-toggle dropdown-indicator"
                                          data-toggle="dropdown"
                                        >
                                          <span
                                            style={{
                                              fontFamily:
                                                this.state.signatureClass,
                                            }}
                                          >
                                            {this.state.signatureText ||
                                              "Your Signature"}
                                          </span>
                                        </a>
                                        <div className="dropdown-menu dropdown-menu-auto">
                                          <ul className="link-list-plain">
                                            {this.cursiveFonts.map(
                                              (font, index) => (
                                                <li key={index}>
                                                  <a
                                                    style={{
                                                      cursor: "pointer",
                                                    }}
                                                    onClick={() =>
                                                      this.handleSignature(
                                                        font.value
                                                      )
                                                    }
                                                    className="cc-pay-item"
                                                  >
                                                    <span className="cc-pay-item-name">
                                                      <span
                                                        className="cc-pay-item-method"
                                                        style={{
                                                          fontFamily:
                                                            font.value,
                                                        }}
                                                      >
                                                        {this.state
                                                          .signatureText !== ""
                                                          ? this.state
                                                            .signatureText
                                                          : font.name}
                                                      </span>
                                                    </span>
                                                  </a>
                                                </li>
                                              )
                                            )}
                                          </ul>
                                        </div>
                                      </li>
                                    </ul>
                                  </div>

                                  <div
                                    className="signature-preview mt-3 mb-4"
                                    id="styled-text-container"
                                    style={{
                                      fontFamily: this.state.signatureClass,
                                      fontSize: "40px",
                                      width: "480px",
                                      height: "80px",
                                      background: "trasnparent",
                                      backgroundColor: "transparent",
                                      border: "none",
                                      lineHeight: "80px",
                                      color: "#000",
                                    }}
                                  >
                                    {this.state.signatureText ||
                                      "Your Signature"}
                                  </div>
                                </div>

                                <div className="row g-gs d-flex justify-content-end mt-5 border-top">
                                  <div className="" style={{ float: "right" }}>
                                    {this.state.quotation_signature &&
                                      this.state.quotation_signature !== "" ? (
                                      <button
                                        className="btn btn-light btn-lg"
                                        style={{
                                          margin: "13px 12px 12px 10px",
                                        }}
                                        onClick={() => this.moveToPayment()}
                                      >
                                        <span>Skip</span>{" "}
                                        <em className="icon ni ni-arrow-right-round"></em>{" "}
                                      </button>
                                    ) : null}
                                    {this.state.finalPayButton === true ? (
                                      <button
                                        className="btn btn-primary btn-lg"
                                        type="button"
                                        id="loading_btn"
                                        disabled
                                      >
                                        <span
                                          className="spinner-grow spinner-grow-sm"
                                          role="status"
                                          aria-hidden="true"
                                        ></span>
                                        <span> Processing... </span>
                                      </button>
                                    ) : this.state.finalPayButton === false ? (
                                      <>
                                        {this.state.unsignedArray &&
                                          this.state.unsignedArray.length ===
                                          0 ? (
                                          <button
                                            className="btn btn-primary btn-lg"
                                            style={{
                                              color: THEME_TEXT_COLOR,
                                              margin: "13px 12px 12px 10px",
                                            }}
                                            onClick={() => this.saveSignature()}
                                            id=""
                                          >
                                            <em className="icon ni ni-check-round-cut"></em>{" "}
                                            <span>Accept & Sign</span>{" "}
                                          </button>
                                        ) : null}
                                      </>
                                    ) : null}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </>
                        ) : null}
                      </div>
                    </div>
                  </div>
                </div>
                {/****** Rejection Modal *****/}
                <div className="modal fade" tabIndex="-1" id="modalRejectQuotation">
                  <div
                    className="modal-dialog modal-dialog-top modal-xl"
                    role="document"
                  >
                    <div className="modal-content">
                      <a
                        href="#"
                        className="close"
                        data-dismiss="modal"
                        aria-label="Close"
                      >
                        <em className="icon ni ni-cross"></em>
                      </a>
                      <div className="modal-header">
                        <h5 className="modal-title">
                          <em className="icon ni ni-cross-round-fill"></em> Reject
                          Quotation
                        </h5>
                      </div>
                      <div className="modal-body">
                        <div className="row g-gs">
                          {this.state.rejectErrorMessage !== "" ? (
                            <div className="col-sm-12 mb-4">
                              <div
                                className="example-alert"
                                style={{ marginBottom: "15px" }}
                              >
                                <div className="alert alert-pro alert-danger">
                                  <div className="alert-text">
                                    <h4>
                                      {this.state.rejectErrorMessageTitle}
                                    </h4>
                                    <p>{this.state.rejectErrorMessage}</p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          ) : null}
                          {this.state.rejectSuccessMessage !== "" ? (
                            <div className="col-sm-12 mb-4">
                              <div
                                className="example-alert"
                                style={{ marginBottom: "15px" }}
                              >
                                <div className="alert alert-pro alert-success">
                                  <div className="alert-text">
                                    <h4>Success</h4>
                                    <p>{this.state.rejectSuccessMessage}</p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          ) : null}
                          <div className="col-sm-12 mb-4">
                            <div className="form-group">
                              <label className="form-label" htmlFor="default-textarea">
                                Reason <sup>*</sup>
                              </label>
                              <div className="form-control-wrap">
                                <textarea
                                  className="form-control"
                                  id="rejection_reason"
                                  name="rejection_reason"
                                  defaultValue={this.state.rejection_reason}
                                  onChange={this.handleChange}
                                  placeholder="Please provide the reason for rejecting the quotation in this space."
                                ></textarea>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="row g-gs d-flex justify-content-end mt-5 border-top">
                          <div className="" style={{ float: "right" }}>
                            {this.state.rejectionButton === true ? (
                              <button
                                className="btn btn-primary btn-lg"
                                type="button"
                                id="loading_btn"
                                style={{
                                  margin: "13px 12px 12px 10px",
                                }}
                                disabled
                              >
                                <span
                                  className="spinner-grow spinner-grow-sm"
                                  role="status"
                                  aria-hidden="true"
                                ></span>
                                <span> Processing... </span>
                              </button>
                            ) : this.state.rejectionButton === false ? (
                              <button
                                className="btn btn-primary btn-lg"
                                style={{
                                  color: THEME_TEXT_COLOR,
                                  margin: "13px 12px 12px 10px",
                                }}
                                onClick={() => this.rejectQuotationSubmit()}
                                id=""
                              >
                                <em className="icon ni ni-cross-round-fill"></em>{" "}
                                <span>Reject</span>{" "}
                              </button>
                            ) : null}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/****** Rejection Modal *****/}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    defaultSettings: state.settings,
    is_msa_signed: state.is_msa_signed,
    quotationSettings: state.quotationSettings,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    addSettings: (payload) => dispatch(addSettings(payload)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(ViewQuotation);
